// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Utilitiy classes */

.spin {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.d-flex {
  display: flex;
}

.flex-grid .flex-grid-child {
  padding: 0 12px;
}

.align-center-v {
  display: flex;
  align-items: center;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-center {
  justify-content: center;
}

.align-items-center {
  align-items: center;
}

.line-height-0 {
  line-height: 0;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.status {
  display: inline !important;
  font-size: 12px;
  font-weight: 500;
  background-color: #868eae10;
  padding: 4.5px 11.85px;
  border-radius: 15px;
}

.status.Success {
  background-color: #20c99710;
  color: #20c997;
}

.status.warning {
  background-color: #fa8b0c10;
  color: #fa8b0c;
}

.status.error {
  background-color: #ff4d4f10;
  color: #ff4d4f;
}

ul {
  list-style: outside none none;
  margin: 0;
  padding: 0;
}

/* spacing classes */

.m-0 {
  margin: 0 !important;
}

.mb-20 {
  margin-bottom: 20px !important;
}
.mb-25 {
  margin-bottom: 25px !important;
}
.mb-30 {
  margin-bottom: 30px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pl-0 {
  padding-left: 0 !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mt-25 {
  margin-top: 25px;
}
.mt-30 {
  margin-top: 30px;
}

.pr-0 {
  padding-right: 0 !important;
}

/* default card style */

.ant-card {
  box-shadow: 0 5px 20px #9299b803;
}

.ant-card-body {
  padding: 25px !important;
}

.ant-card-head {
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.ant-card-head-title span {
  display: inline-block;
  margin-left: 15px;
  font-size: 11px;
  font-weight: 500;
  color: #868eae;
}

.ant-card-head .ant-card-extra {
  display: flex;
  align-items: center;
}

.ant-card-head .ant-card-extra a {
  color: #868eae;
}

.ant-card-extra .ant-dropdown-trigger {
  line-height: 0;
  order: 1;
  margin-left: 20px;
}

.sDash_unresizable {
  resize: none;
}

/* ant radio group */

.ant-radio-button-wrapper-checked {
  color: #fff !important;
}

/* card nav */

.card-nav ul {
  list-style: none;
  display: flex;
  margin: 0 -8px !important;
}

.card-nav ul li {
  margin: 0 8px !important;
  position: relative;
}

.card-nav ul li a {
  font-weight: 500;
  color: #868eae;
  font-size: 12px;
}

.card-nav ul li.active a {
  color: #5f63f2;
  font-weight: 500;
}

.card-nav ul li.active:before {
  position: absolute;
  content: '';
  width: 100%;
  height: 1px;
  background: #5f63f2;
  left: 0;
  bottom: -19px;
}

/* chart growth upward */

.growth-downward p,
.growth-upward p {
  font-size: 14px;
  color: #868eae;
  margin: 0;
}

.growth-downward h1 sub svg,
.growth-upward h1 sub svg {
  position: relative;
  top: 2px;
  font-size: 14px;
  font-weight: 600;
  left: 5px;
  bottom: 0;
}

/*
.growth-downward h1, .growth-upward h1 {
  font-size: 22px;
  margin: 6px 0 0;
} */

.growth-downward h1 sub {
  color: #ff4d4f;
}

.growth-upward h1 sub {
  color: #20c997;
}

/* Chart */

.chart-label {
  display: flex;
}

.chart-label .chart-label__single {
  align-items: center;
}

.chart-label .chart-label__single:not(:last-child) {
  margin-right: 40px;
}

.chart-label .chart-label__single p {
  margin: 0;
  color: #868eae;
}

/* revenue doughnut */

.revenue-doughnut {
  display: flex;
  justify-content: center;
}

.revenue-doughnut > div {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.revenue-doughnut .rd-labels {
  width: 100%;
  margin-top: 30px;
}

.revenue-chat-percentage span {
  display: block;
}

.revenue-chat-percentage span:not(:last-child) {
  margin-bottom: 15px;
}

/* progressbars */

.ant-progress {
  display: inline-flex !important;
  align-items: center;
}

.ant-progress > div {
  display: flex;
  flex-direction: column;
}

.ant-progress .ant-progress-outer {
  margin-right: 0 !important;
  padding-right: 0 !important;
}

.revenue-chat-percentage span {
  display: block;
  font-size: 13px;
  color: #868eae;
}

.revenue-chat-percentage span:not(:last-child) {
  margin-bottom: 20px;
}

.ant-progress-status-warning .ant-progress-bg {
  background: #fa8b0c;
}

/* progress bars */

.progress-primary .ant-progress-bg {
  background: #5f63f2;
}

.progress-secondary .ant-progress-bg {
  background: #ff69a5;
}

.progress-success .ant-progress-bg {
  background: #20c997;
}

.progress-success .progress-info .ant-progress-bg {
  background: #2c99ff;
}

.progress-warning .ant-progress-bg {
  background: #fa8b0c;
}

.progress-danger .ant-progress-bg {
  background: #ff4d4f;
}

/* color classes */

.color-primary {
  color: #5f63f2;
}

.color-secondary {
  color: #ff69a5;
}

.color-info {
  color: #2c99ff;
}

.color-warning {
  color: #fa8b0c;
}

.color-success {
  color: #20c997;
}

.color-danger {
  color: #ff4d4f;
}

.color-dark {
  color: #272b41;
}

.color-error {
  color: #f5222d;
}

.color-gray {
  color: #5a5f7d;
}

/* Button Styles */

.ant-btn.ant-btn-light:focus {
  background: #fff;
  color: #5a5f7d;
}

.button-example .ant-btn {
  margin: 4px;
}

.button-example .ant-btn-group .ant-btn {
  margin: 0;
}

.ant-btn-white {
  color: #5a5f7d !important;
  border-color: #e3e6ef !important;
}

.ant-btn-white:hover {
  color: #5f63f2 !important;
  background-color: #fff !important;
  border-color: #fff;
}

.ant-btn-white:focus {
  background-color: transparent !important;
}

.ant-btn-link {
  background-color: #fff;
  border-color: #fff;
  color: #5f63f2;
}

.ant-btn-link:hover {
  border-color: #fff;
  background: #fff;
}

.ant-btn-light,
.ant-btn-light:hover,
.ant-btn-link:hover,
.ant-btn-dashed {
  color: #5a5f7d !important;
}

.ant-btn-light {
  border-color: #e3e6ef;
  background: #f4f5f7 !important;
}

.ant-btn-light.btn-outlined {
  background: transparent !important;
}

.ant-btn-light.btn-transparent {
  background: #f4f5f715;
}

.ant-btn-dashed {
  border-width: 1px !important;
}

.ant-btn-dashed:hover {
  color: #5f63f2;
  border: 1px dashed #5f63f2;
}

.ant-btn-primary[disabled] {
  color: #fff;
  background: #5f63f260;
}

.ant-btn-light[disabled] {
  background: #fff;
}

.ant-btn-round.ant-btn-sm {
  height: 38px;
}

.ant-btn-white[disabled] {
  background-color: transparent;
  opacity: 0.6;
}

.ant-btn-white[disabled]:hover {
  color: #5a5f7d !important;
}

.ant-btn-primary[disabled]:hover {
  color: #fff !important;
  background: #5f63f260 !important;
}

.btn-icon {
  padding: 0 13px;
}

.btn-inc,
.btn-dec {
  height: 38px;
  width: 38px;
  font-size: 20px;
  padding: 0 12px !important;
  border-radius: 10px !important;
  border: 0 none;
}

.btn-inc:hover,
.btn-dec:hover {
  background: #5f63f210 !important;
  border: 0 none !important;
}

.btn-inc:hover i,
.btn-inc:hover svg,
.btn-dec:hover i,
.btn-dec:hover svg {
  color: #5f63f2;
}

/* input styles */

.ant-form-item-label > label {
  font-weight: 500;
}

.ant-picker-input > input::placeholder {
  color: #adb4d2 !important;
}

/* Calendar Styles */

.ant-picker-calendar-header .ant-select-selector {
  height: 32px !important;
}

.ant-picker-calendar-header .ant-select-selection-search-input {
  height: 30px !important;
}

.ant-select-single .ant-select-selector .ant-select-selection-item {
  line-height: 30px !important;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background: #fff !important;
  color: #5f63f2 !important;
}

/* pagination */

.ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 32px !important;
}

.ant-pagination-item-active {
  background-color: #5f63f2 !important;
}

.ant-pagination-item-active a {
  color: #fff !important;
}

.ant-pagination .ant-pagination-options .ant-select-selection-item {
  font-size: 13px;
  line-height: 30px !important;
}

.ant-pagination .ant-pagination-options .ant-pagination-options-quick-jumper {
  height: 30px;
  line-height: 30px;
}

.ant-pagination .ant-pagination-options .ant-pagination-options-quick-jumper input {
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.ant-pagination .ant-pagination-prev,
.ant-pagination .ant-pagination-next,
.ant-pagination .ant-pagination-jump-prev,
.ant-pagination .ant-pagination-jump-next,
.ant-pagination .ant-pagination-item,
.ant-pagination .ant-pagination-options .ant-select-selector {
  border: 1px solid #f1f2f6 !important;
  background-color: #fff;
}

.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-ellipsis,
.ant-pagination .ant-pagination-jump-next .ant-pagination-item-ellipsis {
  color: #5a5f7d !important;
  line-height: 2.6;
}

.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-link,
.ant-pagination .ant-pagination-jump-next .ant-pagination-item-link {
  display: block;
}

.ant-pagination-prev,
.ant-pagination-next {
  line-height: 28px !important;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  border: 0 none !important;
}

.ant-pagination .ant-pagination-item a {
  color: #5a5f7d;
}

.ant-pagination .ant-select-single .ant-select-selector .ant-select-selection-item {
  line-height: 30px !important;
  color: #5a5f7d;
}

.ant-pagination
  .ant-select-single:not(.ant-select-customize-input)
  .ant-select-selector
  .ant-select-selection-search-input {
  height: 100% !important;
}

.ant-pagination {
  margin: -4px -12px !important;
}

.ant-pagination-item,
.ant-pagination-options,
.ant-pagination-prev,
.ant-pagination-jump-prev,
.ant-pagination-jump-next,
.ant-pagination-next {
  margin: 4px !important;
}

.ant-table-pagination {
  margin-top: 30px !important;
}

/* Wizard Modal */
.submission-successModal {
  text-align: center;
}
.submission-successModal .icon-success {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 1px solid #20c997;
}
.submission-successModal p {
  margin-bottom: 0;
}
.submission-successModal .icon-success svg {
  color: #20c997;
}
.submission-successModal .submission-action {
  margin: 30px -5px -5px -5px;
}
.submission-successModal .submission-action button {
  margin: 5px;
  height: 38px;
}

/* Tree Select */

.ant-tree-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 42px !important;
  line-height: 40px;
}

.ant-tree-select.ant-select-single:not(.ant-select-customize-input)
  .ant-select-selector
  .ant-select-selection-search-input {
  height: 100% !important;
}

.ant-tree-select.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 40px !important;
}

/* radio style */

.ant-radio-checked .ant-radio-inner {
  border-width: 5px !important;
}

.ant-radio-inner::after {
  content: none !important;
}

/* Statistics */

.ant-statistic .ant-statistic-title {
  color: #9299b8;
}

.ant-statistic .ant-statistic-content span {
  font-size: 20px;
}

/* Steps */

.steps-action.justify-content-center {
  justify-content: center !important;
}

/* rate */

.ant-rate-star.ant-rate-star-zero span svg {
  color: #c6d0dc;
}

.ant-rate-star:not(:last-child) {
  margin-right: 2px !important;
}

.ant-rate-text {
  color: #5a5f7d;
}

/* result */

.ant-result-icon {
  margin-bottom: 20px !important;
}

.ant-result-title {
  font-weight: 500;
  margin-bottom: 10px;
}

.ant-result-extra {
  height: 34px;
  padding: 4px 10.72px;
}

.ant-result-content .ant-typography strong {
  font-weight: 500;
}

.ant-result-content .ant-typography:last-child {
  margin-bottom: 0;
}

/* form select */

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 38px !important;
}

.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 33px !important;
}

.ant-select-multiple .ant-select-selector {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.sDash_fullwidth-select {
  width: 100%;
}

/* Nasted Comments Styles */

.nested-comment-wrapper .comment-title {
  font-size: 12px;
  padding-bottom: 10px;
  margin-bottom: 22px;
  border-bottom: 1px solid #e3e6ef;
}

/* calendar style */

.events {
  list-style: none;
  margin: 0;
  padding: 0;
}

.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}

.notes-month {
  text-align: center;
  font-size: 28px;
}

.notes-month section {
  font-size: 28px;
}

/* Breadcrumb demo */

.demo {
  margin: 16px;
}

.demo-nav {
  height: 30px;
  line-height: 30px;
  margin-bottom: 16px;
  background: #f8f8f8;
}

.demo-nav a {
  line-height: 30px;
  padding: 0 8px;
}

.app-list {
  margin-top: 16px;
}

/* Modal */

.ant-modal .ant-modal-content {
  border-radius: 10px;
}

.ant-modal .ant-modal-header {
  border-radius: 10px 10px 0 0;
}

.ant-modal-body p:last-child {
  margin-bottom: 0;
}

.project-modal {
  padding: 5px !important;
}

.project-modal .projects-members {
  margin-top: -12px;
}

.project-modal .ant-form-item-control-input {
  margin-top: 10px;
  min-height: auto;
}

.project-modal .ant-select-selector {
  border-color: #e3e6ef;
}

.project-modal-footer {
  padding: 10px !important;
  text-align: left !important;
}

.sDash_addTask-modal {
  max-width: 390px;
}
.sDash_addTask-modal .ant-modal-header {
  border-bottom: 0 none;
  padding-bottom: 0 !important;
}
.sDash_addTask-modal .ant-modal-header .ant-modal-title {
  font-size: 16px;
  font-weight: 500;
  color: #272b41;
}
.sDash_addTask-modal .sDash_addTask-modal-inner .ant-form-item {
  margin-bottom: 15px;
}
.sDash_addTask-modal .ant-modal-header .ant-modal-close-x svg {
  color: #9299b8;
}
.sDash_addTask-modal .ant-form-item-control-input {
  min-height: 36px;
}
.sDash_addTask-modal input::placeholder,
.sDash_addTask-modal textarea::placeholder {
  color: #9299b8;
}
.sDash_addTask-modal input,
.sDash_addTask-modal textarea {
  padding: 6px 20px;
  border-radius: 5px;
}
.sDash_addTask-modal textarea {
  resize: none;
  min-height: 125px;
}
.sDash_addTask-modal .sDash-modal-actions {
  display: flex;
  justify-content: flex-end;
  margin: -6px;
}
.sDash_addTask-modal .sDash-modal-actions button {
  font-size: 14px;
  margin: 6px;
  height: 38px;
  border-radius: 5px;
}
/* slider */

.ant-slider-handle {
  margin-top: -6px !important;
}

/* tags */

.ant-tag {
  font-weight: 600;
  padding: 0 9.5px;
}

/* tabs */

.ant-tabs-tab span {
  display: flex;
  align-items: center;
}

/* list */

.ant-list-bordered {
  border-color: #e3e6ef !important;
}

.ant-list-item-meta {
  padding: 10px 24px;
  border-bottom: 1px solid #f1f2f6;
}

/* popover */

.ant-popover {
  position: fixed;
  z-index: 99999;
}

.ant-popover-inner {
  padding: 15px;
  box-shadow: 0 5px 20px #9299b820;
  border-radius: 0 0 6px 6px;
}

.ant-popover-inner .ant-popover-title {
  padding: 5px 10px 10px;
}

.ant-popover-inner .ant-popover-inner-content a {
  color: #5a5f7d;
}

/* Drawer */

.ant-drawer {
  z-index: 99999;
}

/* Select Dropdwon */

.ant-select-dropdown {
  padding: 18px 0 !important;
  box-shadow: 0 5px 20px #9299b820 !important;
  border-radius: 0 0 6px 6px !important;
}

.ant-select-item {
  min-height: 20px !important;
  padding: 4px 12px !important;
}

.ant-select-item-group {
  color: #9299b8;
}

.ant-select-item.ant-select-item-option-grouped {
  padding-left: 25px !important;
}

.ant-select-dropdown .ant-select-item.ant-select-item-option-active {
  background: #5f63f205;
}

.ant-select-dropdown .ant-select-item.ant-select-item-option-selected .ant-select-item-option-content {
  padding-left: 10px;
}

.ant-select-dropdown .ant-select-item.ant-select-item-option-selected {
  color: #5f63f2;
  background: #5f63f206;
}

.ant-select-dropdown .ant-select-item.ant-select-item-option-selected .ant-select-item-option-content {
  color: #5f63f2;
  font-weight: 500;
}

.ant-select-dropdown .ant-select-item .ant-select-item-option-content {
  transition: 0.3s;
  color: #5a5f7d;
}

/* mail props dropdown */

.mail-props {
  padding: 5px 25px;
  border: 0 none;
  background: #fff;
  /* box-shadow: 0 5px 40px rgba(146, 153, 184, 0.25); */
}

.mail-props li {
  display: flex;
  margin-bottom: 12px;
}

.mail-props li span:first-child {
  margin-right: 50px;
  min-width: 40px;
}

.mail-props li span:last-child {
  color: #5a5f7d;
}

.mail-props li:last-child {
  margin-bottom: 0;
}

.mail-props li span {
  color: #9299b8;
}

/* Basic Dropdwon */

.ant-dropdown {
  box-shadow: 0 5px 30px #9299b820 !important;
}

.ant-dropdown.wide-dropdwon {
  min-width: 140px !important;
}

.ant-dropdown.wide-dropdwon.kanbanCard-more {
  min-width: 220px !important;
  box-shadow: 0 17px 20px #9299b820;
}
.ant-dropdown.wide-dropdwon.kanbanCard-more a {
  padding: 10px 24px;
}

.ant-dropdown-menu {
  min-width: 200px;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 0;
}

.ant-dropdown-menu li {
  color: #5a5f7d;
  padding: 5px 25px;
}

.ant-dropdown-menu li:hover {
  background-color: #5f63f205;
}

.atbd-top-dropdwon .atbd-top-dropdwon__title {
  background: #f4f5f7;
  width: 100%;
  margin-bottom: 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  min-height: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.atbd-top-dropdwon {
  width: 340px;
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav {
  height: 260px;
  overflow: hidden;
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav.notification-list {
  padding: 0 10px;
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav li {
  width: 100%;
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav li a {
  padding: 13px 10px;
  position: relative;
  width: 100%;
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav li:last-child {
  margin: 0;
}

.atbd-top-dropdwon a.btn-seeAll {
  position: relative;
  width: calc(100% + 30px);
  left: -15px;
  right: -15px;
  height: calc(100% + 15px);
  bottom: -15px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #5f63f2;
  padding: 15px 0;
  border-radius: 0 0 6px 6px;
  background: #fff;
}

.atbd-top-dropdwon a.btn-seeAll:before {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 -15px 20px #9299b808;
  z-index: 1;
  content: '';
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav li a.btn-seeAll:hover:after {
  box-shadow: 0 0;
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav li a:hover {
  background: #fff;
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav li a:hover:after {
  opacity: 1;
  visibility: visible;
}

.atbd-top-dropdwon .atbd-top-dropdwon__nav li a:after {
  position: absolute;
  left: -15px;
  right: -15px;
  top: 0;
  width: calc(100% + 30px);
  height: 100%;
  box-shadow: 0 15px 50px #9299b820;
  z-index: 1;
  content: '';
  opacity: 0;
  visibility: hidden;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-icon {
  width: 39.2px;
  height: 32px;
  margin-right: 15px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-icon.bg-primary {
  background: #5f63f215;
  color: #5f63f2;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-icon.bg-secondary {
  background: #ff69a515;
  color: #ff69a5;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-icon svg {
  width: 18px;
  height: 18px;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.atbd-top-dropdwon .notification-text h1 {
  font-size: 14px;
  font-weight: 400;
  color: #5a5f7d;
  margin-bottom: 4px;
}

.atbd-top-dropdwon .notification-text h1 span {
  color: #5f63f2;
  font-weight: 500;
  padding-left: 0;
}

.atbd-top-dropdwon .notification-text p {
  font-size: 12px;
  color: #adb4d2;
  margin-bottom: 0;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content img {
  max-width: 40px;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption {
  margin: -4px 15px 0;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption .ant-badge-count {
  font-size: 8px;
  min-width: 16px;
  width: 16px;
  height: 16px;
  line-height: 6px;
  border-radius: 8px;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption p.ant-scroll-number-only-unit.current {
  height: 15px;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption h1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption h1 span {
  font-size: 12px;
  font-weight: 400;
}

.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption p {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.add-file-dropdown a {
  font-size: 14px;
  font-weight: 400;
}
.add-file-dropdown a svg {
  width: 14px;
}

.folder-dropdown {
  min-width: 200px !important;
}

/* Tooltip Styles */

.ant-tooltip .ant-tooltip-inner {
  min-height: 40px;
  padding: 6px 20px;
  font-size: 14px;
  color: #5a5f7d;
  background-color: #fff;
  border-radius: 3px;
  display: flex;
  align-items: center;
  border: 1px solid #f1f2f6;
  box-shadow: 0 8px 15px #9299b815;
}

.ant-tooltip .ant-tooltip-arrow {
  /* position: relative; */
}

.ant-tooltip .ant-tooltip-arrow:after {
  position: absolute;
  left: 50%;
  top: 12px;
  transform: translateX(-50%);
  width: 13px;
  height: 13px;
  background: #fff;
  content: '';
}

.ant-tooltip .ant-tooltip-arrow .ant-tooltip-arrow-content {
  width: 10px;
  height: 10px;
  background: #fff;
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow .ant-tooltip-arrow-content {
  border: 1px solid #f1f2f6;
  box-shadow: 0 0;
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow {
  top: -4.071068px;
}

/* Badge Styles */

.ant-badge.badge-success .ant-badge-count {
  background: #20c997;
}

.badge {
  font-size: 11px;
  font-weight: 500;
  padding: 0 6.5px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.badge.badge-primary {
  background: #5f63f210;
  color: #5f63f2;
}

/* Cascade Styles */

.custom-cascade-render .ant-cascader-picker {
  width: 100%;
}

.ant-cascader-picker input::placeholder {
  color: #adb4d2;
}

/* Comment Styles */

.ant-comment-actions li {
  margin-bottom: 0 !important;
}

/* Radio Vertical Button */

.ant-radio-vertical .ant-radio-wrapper {
  display: block;
}

.ant-radio-vertical .ant-radio-wrapper:not(:last-child) {
  margin-bottom: 14px;
}

/* Select Tree */

.ant-select-tree-list .ant-select-tree-node-content-wrapper:hover {
  background-color: #bae7ff !important;
}

.ant-select-tree-list .ant-select-arrow svg {
  font-size: 10px;
}

.ant-tree-select.ant-select-multiple .ant-select-selection-item {
  border: 0 none;
  border-radius: 3px;
  background: #f4f5f7;
  color: #5a5f7d;
  font-weight: 500;
}

/* Ant Switch */

.ant-switch:after {
  width: 14px !important;
  height: 14px !important;
}

.ant-switch-small:after {
  width: 10px !important;
  height: 10px !important;
}

/* Time Picker */

.ant-picker {
  min-width: 250px;
}

/* Input Affix */

.ant-input-affix-wrapper > input.ant-input {
  padding-left: 5px;
}

.ant-input-affix-wrapper .ant-input-prefix svg {
  color: #e3e6ef;
}

/* Space Item */

.ant-space-item .ant-btn span {
  font-size: 14px;
}

/* Pop confirm */

.pop-confirm .ant-btn {
  max-width: 90px;
  padding: 0px 35.5px;
  height: 44px;
}

.pop-confirm-top {
  margin-bottom: 10px;
}

.pop-confirm-bottom {
  margin-top: 10px;
}

.pop-confirm-top .ant-btn:not(:last-child),
.pop-confirm-bottom .ant-btn:not(:last-child) {
  margin-right: 10px;
}

.pop-confirm-left .ant-btn:not(:last-child),
.pop-confirm-right .ant-btn:not(:last-child) {
  margin-bottom: 10px;
}

/* Ant Upload */

.ant-upload .ant-btn {
  font-size: 14px;
  border-radius: 5px;
}

.ant-upload.ant-upload-select-picture-card {
  border-color: #e3e6ef !important;
  border-radius: 5px !important;
  background-color: #f8f9fb !important;
}

.ant-upload.ant-upload-select-picture-card .anticon {
  margin-bottom: 8px;
}

.ant-upload .anticon svg {
  color: #9299b8;
}

.ant-upload-list {
  margin-top: 10px !important;
}

.sDash_upload-basic .ant-upload.ant-upload-select {
  width: 100%;
  border: 1px solid #e3e6ef;
  border-radius: 4px;
}
.sDash_upload-basic .ant-upload.ant-upload-select .ant-upload {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sDash_upload-basic .sDash_upload-text {
  font-size: 14px;
  color: #9299b8;
  padding-left: 15px;
}
html[dir='rtl'] .sDash_upload-basic .sDash_upload-text {
  padding-left: 0px;
  padding-right: 15px;
}
.sDash_upload-basic .sDash_upload-browse {
  font-size: 14px;
  color: #9299b8;
  display: inline-block;
  padding: 14px 23px;
  border-left: 1px solid #e3e6ef;
}
html[dir='rtl'] .sDash_upload-basic .sDash_upload-browse {
  border-left: 0 none;
  border-right: 1px solid #e3e6ef;
}
.ant-card.sDash_upload-form .ant-card-body {
  padding-bottom: 15px !important;
}
/* Ant Picker */

.ant-picker {
  border-color: #e3e6ef !important;
}

/* Ant Dropdown */

.ant-dropdown {
  box-shadow: 0 5px 20px #9299b820;
  background: #fff;
  border-radius: 6px;
  padding: 15px 0 !important;
  border: 0 none;
}

.ant-dropdown a {
  display: flex;
  align-items: center;
  padding: 8px 24px;
  font-weight: 400;
  color: #5a5f7d;
}

.ant-dropdown a i,
.ant-dropdown a svg,
.ant-dropdown a img {
  margin-right: 8px;
}

.ant-dropdown div {
  box-shadow: 0 0;
  border-radius: 5px;
}

/* Picker Under Input */

.ant-form-item-control-input .ant-picker {
  padding: 0 12px 0 0;
}

/* Leaflet COntainer */

.leaflet-container {
  z-index: 0;
}

/* Table Bordered*/

.table-bordered .ant-table-tbody > tr.ant-table-row:hover > td {
  background: #f8f9fb !important;
}

.table-bordered .ant-table-thead > tr > th {
  background: #fff;
  border-top: 1px solid #f1f2f6;
}

.table-bordered .ant-table-tbody > tr > td {
  border-color: #f1f2f6 !important;
}

.table-bordered .ant-table-thead tr th,
.table-bordered .ant-table-tbody tr td {
  padding: 16px 25px;
}

.table-bordered .ant-table-thead tr th:last-child,
.table-bordered .ant-table-tbody tr td:last-child {
  text-align: right;
}

/* Full Width Table */

.full-width-table .ant-card-body {
  padding: 0 !important;
}

.full-width-table .ant-table {
  border-radius: 10px !important;
}

.full-width-table .top-seller-table {
  min-height: 406px;
}

.full-width-table .top-seller-table .ant-table-content .ant-table-cell {
  white-space: normal;
  padding: 16px 15px;
}

.full-width-table .top-seller-table .ant-table-content .ant-table-cell:first-child {
  padding-left: 25px;
}

.full-width-table .top-seller-table .ant-table-content .ant-table-cell:last-child {
  padding-right: 25px;
}

.full-width-table .top-seller-table th {
  text-align: right;
  color: #272b41;
  font-weight: 500;
}

.full-width-table .top-seller-table td {
  color: #5a5f7d;
}

.full-width-table .top-seller-table .ant-table-tbody > tr > td {
  text-align: right;
}

.full-width-table .top-seller-table th:first-child,
.full-width-table .top-seller-table td:first-child {
  text-align: left !important;
}

/* Table Responsive */

.table-responsive .ant-table-content {
  display: block;
  width: 100%;
  overflow-x: auto;
}

.table-responsive .ant-table-content .ant-table-cell {
  white-space: nowrap;
}

/* Rich TextEditor  */

.RichTextEditor__root___2QXK- {
  border: 0 none !important;
}

.RichTextEditor__root___2QXK- .EditorToolbar__root___3_Aqz {
  margin: 0;
  border-color: #f1f2f6;
}

.RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button {
  padding: 0;
  border: 0 none;
  background: #fff;
  margin-right: 8px;
}

.RichTextEditor__root___2QXK- .Dropdown__root___3ALmx .Dropdown__value___34Py9 {
  border: 0 none;
}

.RichTextEditor__root___2QXK- .Dropdown__root___3ALmx select {
  border-right-width: 0px;
}

.RichTextEditor__editor___1QqIU .DraftEditor-editorContainer {
  border: 0 none;
}

/* ChatBox Dropdwon */

.atbd-chatbox__messageControl {
  min-width: 210px;
}

.atbd-chatbox__messageControl ul li a {
  padding: 4px 24px;
}

.atbd-chatbox__emoji {
  margin: -4.48px 0;
  padding: 0 10px;
}

.atbd-chatbox__emoji ul {
  display: flex;
  align-items: center;
}

.atbd-chatbox__emoji ul li {
  display: inline-block;
}

.atbd-chatbox__emoji ul li a {
  display: block;
  font-size: 20px;
  padding: 4px 7px;
  background: #fff;
}

.atbd-chatbox__emoji ul li a:hover {
  background-color: transparent;
}

.atbd-chatbox__emoji ul li a svg {
  margin: 0;
}

.rdrMonths {
  flex-wrap: wrap;
}

.ant-space {
  flex-wrap: wrap;
}

.ant-menu .ant-menu-submenu .ant-menu-submenu-title {
  display: flex;
  align-items: center;
}

.ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title,
.ant-menu-item {
  display: inline-flex;
}

.ant-menu-submenu-popup {
  z-index: 105;
}

.ant-menu-submenu-popup .ant-menu-sub {
  padding: 8px 0;
}

.ant-menu-submenu-popup .ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title,
.ant-menu-submenu-popup .ant-menu-item {
  display: block;
}

.ant-menu-submenu-popup .ant-menu-item {
  margin-bottom: 0 !important;
}
.ant-menu-sub.ant-menu-vertical {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.ant-menu-sub.ant-menu-vertical .ant-menu-item a {
  color: #5a5f7d;
}

/* page heading */

.ant-page-header {
  padding: 26px 30px 26px 30px !important;
}

.ant-page-header.header-boxed {
  padding: 26px 180px 26px 180px !important;
}

.ant-page-header-heading {
  align-items: center;
}

.ant-page-header-heading-title {
  text-transform: capitalize;
}

/* Antd drag & drop */

.row-dragging {
  /* background: #fafafa; */
  /* border: 1px solid #ccc; */
  box-shadow: 0 15px 50px #9299b820;
  display: flex;
}

.row-dragging tr {
  box-shadow: 0 15px 50px #9299b820;
}

.row-dragging td {
  padding: 16px;
  color: #000;
  position: relative;
  z-index: 9999;
  opacity: 0.5;
  vertical-align: middle;
}

.row-dragging td .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #20c997;
  border-color: #20c997;
}

.row-dragging td .todos-action,
.row-dragging td .table-actions {
  display: none;
}

.row-dragging td .user-info figcaption {
  display: none;
}

.row-dragging td .feather-move,
.row-dragging td .drag_email,
.row-dragging td .drag_company,
.row-dragging td .drag_designation,
.row-dragging td .drag_join-date,
.row-dragging td .active {
  display: inline-block;
  margin-top: 10px;
}

.row-dragging .drag-visible {
  visibility: visible;
}

/* File Export Import Modal */
.sDash_export-wrap .ant-modal {
  width: 390px !important;
}
.sDash_export-wrap .ant-modal .ant-modal-header {
  border-bottom: 0 none;
  padding: 18px 30px 0 30px;
}
.sDash_export-wrap .ant-modal .ant-modal-body {
  padding: 25px 30px 30px 30px;
}
.sDash_export-wrap .ant-modal .sDash-button-grp {
  text-align: right;
  margin: 20px -8px -8px -8px;
}
.sDash_export-wrap .ant-modal .sDash-button-grp button {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  height: 40px;
  padding: 0 16px;
  margin: 8px;
}
.sDash_export-wrap .ant-modal .sDash-button-grp button.ant-btn-white {
  color: #9299b8 !important;
}
.sDash_export-wrap .ant-form-item-control-input {
  min-height: 36px;
}

.sDash_export-wrap .ant-form-item-control-input input {
  font-size: 14px;
  font-weight: 400;
  padding: 6px 20px;
  border-radius: 5px;
  color: #9299b8;
}

.sDash_export-wrap .ant-select-single {
  width: 100% !important;
}

.sDash_export-wrap .ant-form .ant-form-item {
  margin-bottom: 15px;
}

.sDash_export-wrap .ant-select-single .ant-select-selector {
  padding: 0 20px;
  border-color: #e3e6ef !important;
}

.sDash_create-file .sDash-button-grp {
  text-align: right;
}

.sDash_create-file .ant-modal {
  width: 390px !important;
}
.sDash_create-file .ant-modal .ant-form-item {
  margin-bottom: 20px;
}
.sDash_create-file .ant-modal-header {
  border-bottom: 0 none;
  padding-bottom: 6px;
}
.sDash_create-file .sDash-button-grp button {
  height: 40px;
  border-radius: 5px;
  margin: 5px;
}

.sDash_create-file .ant-form-item-control-input {
  border-radius: 5px;
}

.sDash_create-file .ant-form-item-control-input input {
  border: 1px solid #e3e6ef;
}

/* Task Modal */
.sDash_task-details .ant-modal-content .ant-modal-close {
  top: 10px;
}
.sDash_task-details .ant-modal-header {
  border-bottom: 0 none;
  padding: 30px 30px 0;
}
.sDash_task-details .ant-modal {
  width: 600px !important;
}
.sDash_task-details .ant-modal-header .ant-modal-title h4 {
  font-size: 20px;
  font-weight: 500;
  color: #272b41;
  margin-bottom: 4px;
}
.sDash_task-details .ant-modal-header .ant-modal-title .sub-text {
  font-size: 14px;
  font-weight: 400;
  color: #868eae;
}
.sDash_task-details .sDash_task-details-modal .sDash_task-details__label {
  font-size: 16px;
  display: block;
  margin-bottom: 8px;
}
.sDash_task-details .sDash_task-details-modal .sDash_task-details-modal__description textarea {
  padding: 10px 20px;
  min-height: 88px;
  width: 100%;
  border: 0 none;
  border-radius: 4px;
  background-color: #f4f5f7;
  resize: none;
}
.sDash_task-details .sDash_task-details-modal .sDash_task-details-modal__description textarea:focus {
  outline: none;
}
.sDash_task-details .sDash_task-details-modal .sDash_task-details-modal__description textarea::placeholder {
  color: #5a5f7d;
  font-size: 15px;
}
.sDash_task-details .ant-modal-body {
  padding: 14px 30px 30px 30px;
}
.sDash_task-details .ant-modal-body .sDash_checklist-block {
  margin-top: 26px;
}

.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-wrap {
  position: relative;
}

.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form {
  position: absolute;
  width: 240px;
  padding: 18px;
  left: 0;
  top: 50px;
  box-shadow: 0 15px 30px #9299bb30;
  background-color: #fff;
  border: 1px solid #e3e6ef;
  border-radius: 6px;
  z-index: 222;
}

html[dir='rtl'] .sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form {
  left: auto;
  right: 0;
}

.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .add-checklist {
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
  width: 100%;
  height: 38px;
  border: 1px solid #e3e6ef;
}

.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .addChecklist-form-action {
  margin-top: 15px;
}

.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .addChecklist-form-action a {
  position: relative;
  top: 3px;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}
.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .addChecklist-form-action a svg {
  color: #9299bb;
}
.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .addChecklist-form-action .btn-add {
  margin-right: 15px;
}
html[dir='rtl']
  .sDash_task-details
  .ant-modal-body
  .sDash_checklist-block
  .addChecklist-form
  .addChecklist-form-action
  .btn-add {
  margin-left: 15px;
  margin-right: 0;
}

.sDash_task-details .ant-modal-body .sDash_checklist-block button {
  height: 38px;
  padding: 0px 18.37px;
}

.sDash_task-details .ant-modal-body .sDash_checklist-row {
  margin-top: 26px;
}
.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist-item:not(:last-child) {
  margin-bottom: 30px;
}

.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist-item__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist-item__top button {
  padding: 0px 16.32px;
}

.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist-item__title {
  font-size: 16px;
  font-weight: 500;
  color: #272b41;
  margin-bottom: 0;
}

.sDash_task-details
  .ant-modal-body
  .sDash_checklist-row
  .sDash_checklist__progress
  .ant-progress-inner
  .ant-progress-bg {
  height: 5px !important;
  background-color: #20c997;
}
.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist__progress .ant-progress .ant-progress-text {
  font-size: 12px;
  font-weight: 500;
  order: -1;
  margin: 0 10px 0 0;
}
html[dir='rtl']
  .sDash_task-details
  .ant-modal-body
  .sDash_checklist-row
  .sDash_checklist__progress
  .ant-progress
  .ant-progress-text {
  margin: 0 0 0 10px;
}
.sDash_task-details .ant-modal-body .sDash_checklist-tasks {
  margin: 5px 0 5px 0;
}
.sDash_task-details .ant-modal-body .sDash_checklist-tasks .ant-checkbox-wrapper .ant-checkbox-inner {
  width: 18px;
  height: 18px;
  border-color: #c6d0dc;
}
.sDash_task-details
  .ant-modal-body
  .sDash_checklist-tasks
  .ant-checkbox-wrapper
  .ant-checkbox-checked
  .ant-checkbox-inner {
  background-color: #20c997;
}
.sDash_task-details .ant-modal-body .sDash_checklist-tasks .ant-checkbox-wrapper .ant-checkbox-checked:after {
  border-color: #20c997;
}

.sDash_task-details .ant-modal-body .sDash_checklist-item .sDash_checklist-tasks-wrap button {
  padding: 0px 35px;
}

.sDash_task-details .ant-modal-body {
  max-height: 800px;
  overflow-y: auto;
}

@media (max-width: 767px) {
  .ant-page-header {
    padding: 26px 15px 26px 15px !important;
  }
}

.page-header-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: -6px -4px;
}

.page-header-actions button {
  font-size: 12px;
  font-weight: 500;
  height: 34px;
  padding: 0 12.32px;
  box-shadow: 0 3px 5px #9299b805;
  margin: 6px 4px;
}

.page-header-actions button.ant-btn-white:focus {
  background-color: #fff !important;
}

.page-header-actions button + button {
  margin-left: 8px;
}

.page-header-actions button.ant-btn-white svg {
  width: 12px;
  height: 12px;
  margin-right: 2px;
  color: #5f63f2;
}

/* Layout Css */

.ant-menu-dark .ant-menu-inline.ant-menu-sub,
.ant-menu.ant-menu-dark,
.ant-menu-dark .ant-menu-sub {
  background: #272b41 !important;
}

.ant-menu-dark .ant-menu-item a {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.65) !important;
}

.ant-menu-dark .ant-menu-item a:hover {
  color: #ffffff;
}

.ant-menu-dark .ant-menu-submenu span {
  color: rgba(255, 255, 255, 0.65) !important;
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: rgba(255, 255, 255, 0.05);
}

.ant-menu-inline-collapsed-tooltip a {
  color: #000 !important;
}

.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background: transparent;
}

/* Chart Label */

.chart-label {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  color: #5a5f7d;
}

.chart-label .label-dot {
  margin-right: 8px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.chart-label .label-dot.dot-success {
  background: #20c997;
}

.chart-label .label-dot.dot-info {
  background: #5f63f2;
}

.chart-label .label-dot.dot-warning {
  background: #fa8b0c;
}

/* NOtification CSS */

.ant-notification {
  z-index: 99999 !important;
}

.rdrInputRange {
  padding-left: 10px !important;
}

/* Overlay Dark */
.overlay-dark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #10122130;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
}
.overlay-dark.show {
  z-index: 999;
  opacity: 1;
  visibility: visible;
}

.ant-table-thead
  > tr
  > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  display: none;
}

/* Responsive CSS */

@media only screen and (max-width: 1599px) {
  .ant-page-header.header-boxed {
    padding: 26px 130px 26px 130px !important;
  }
}
@media only screen and (max-width: 1500px) {
  .full-width-table .revenue-table {
    min-height: 100%;
  }
  .pop-confirm .ant-btn {
    padding: 0 20px;
    max-width: 60px;
  }
  .pop-confirm.pop-confirm-right {
    margin-left: 300px !important;
  }
  .pop-confirm.pop-confirm-bottom,
  .pop-confirm.pop-confirm-top {
    margin-left: 80px !important;
  }
}

@media only screen and (max-width: 1399px) {
  .ant-page-header.header-boxed {
    padding: 26px 50px 26px 50px !important;
  }
}

@media only screen and (max-width: 1199px) {
  .ant-page-header {
    padding: 0 15px;
  }
}

@media only screen and (max-width: 991px) {
  .ant-page-header.header-boxed {
    padding: 26px 30px 26px 30px !important;
  }
  .rdrMonths .rdrMonth {
    width: 100%;
    margin-bottom: 30px;
  }
  .rdrDateRangePickerWrapper.PreviewArea {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .rdrCalendarWrapper.rdrDateRangeWrapper {
    margin-top: 20px;
  }
  .ant-menu-inline-collapsed-tooltip {
    display: none;
  }
}

@media only screen and (max-width: 800px) {
  .ant-page-header-heading-left {
    max-width: 320px;
  }
}

@media only screen and (max-width: 767px) {
  .ant-page-header {
    padding: 26px 15px 26px 15px !important;
  }
  .ant-page-header-heading {
    flex-flow: column;
    align-items: center;
    justify-content: center !important;
  }
  .ant-page-header-heading-left {
    max-width: 100%;
  }
  .ant-page-header-heading .ant-page-header-heading-title {
    margin-right: 0;
    white-space: normal;
    text-align: center;
  }
  .ant-page-header-heading-extra {
    white-space: normal !important;
    margin: 12px 0 4px !important;
  }
  .ant-page-header-heading-extra .page-header-actions {
    white-space: normal !important;
    text-align: center;
  }
  .ant-card-body {
    padding: 20px !important;
  }
  .ant-card-head {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .ant-pagination .ant-pagination-item,
  .ant-pagination .ant-pagination-item.ant-pagination-prev,
  .ant-pagination .ant-pagination-item.ant-pagination-next,
  .ant-pagination .ant-pagination-jump-prev {
    margin-right: 5px;
  }
  .ant-pagination li.ant-pagination-item,
  .ant-pagination li.ant-pagination-prev,
  .ant-pagination li.ant-pagination-next {
    height: 25px;
    min-width: 25px;
    line-height: 22px;
  }
  .ant-pagination li.ant-pagination-prev .anticon,
  .ant-pagination li.ant-pagination-next .anticon {
    vertical-align: 0.15em;
  }
  .ant-table-pagination {
    float: none !important;
    text-align: center;
  }
  .ant-table-pagination li.ant-pagination-total-text {
    display: block;
    margin-bottom: 8px;
  }
  .ant-table-pagination li {
    margin-right: 8px !important;
  }
  .ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 25px !important;
  }
  .ant-pagination .ant-select-single .ant-select-selector .ant-select-selection-item {
    line-height: 23px !important;
  }
  .rdrDefinedRangesWrapper {
    border-right: 0 none;
  }
}

@media only screen and (max-width: 575px) {
  .btn-inc,
  .btn-dec {
    height: 30px;
    width: 30px;
  }
  .ant-page-header {
    padding: 16px 20px !important;
  }
  .ant-layout-header {
    height: auto;
  }
  .ant-card-head {
    line-height: 1;
  }
  .ant-card-head-title {
    white-space: normal !important;
  }
  .pop-confirm .ant-btn {
    max-width: 60px;
    padding: 0 20px;
  }
  .pop-confirm.pop-confirm-right {
    margin-left: 320px !important;
  }
  .pop-confirm.pop-confirm-bottom {
    margin-left: 95px !important;
  }
  /* Card Heading */
  .ant-card-head-wrapper {
    flex-flow: column;
    align-items: center;
  }
  .ant-card-head-wrapper .ant-card-extra {
    padding: 10px 0 16px !important;
    float: none;
    margin: 0;
    flex-flow: column;
  }
  .ant-card-head-wrapper .ant-card-extra .ant-dropdown-trigger + .card-nav {
    margin-bottom: 8px;
  }
  .ant-card-head-wrapper .ant-card-extra .ant-dropdown-trigger {
    margin: 0 !important;
  }
  .ant-card-head-wrapper .ant-card-head-title {
    padding: 20px 0 0px !important;
  }
  .card-nav ul li.active:before {
    display: none;
  }
  .ant-card-head-title > div {
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .ant-card-head-title > div span {
    margin: 8px 0 0;
  }
}

.bmzxig .ant-table tr th:first-child,
.bmzxig .ant-table tr td:first-child {
  padding-right: 15px;
}

/* Emprt */

.ant-empty .ant-empty-footer button {
  padding: 0px 15.58px !important;
}

/* Add Event Modal */
.addEvent-modal .ant-modal-header {
  padding: 20px 25px;
}
.addEvent-modal .ant-modal-header .ant-modal-close-x svg {
  color: #5a5f7d;
}
.addEvent-modal .ant-modal-header .ant-modal-title {
  font-size: 15px;
  font-weight: 500;
  color: #272b41;
}

.addEvent-modal .ant-modal-body {
  padding: 23px 25px;
}

/* Event Dropdown */

.event-dropdown {
  min-width: auto !important;
  max-width: 450px;
  padding: 0 !important;
  margin: 6px 0 0 !important;
  box-shadow: 0 10px 40px #9299b820 !important;
}

.event-dropdown div {
  border-radius: 8px;
}

.event-dropdown .ant-card {
  width: 100% !important;
  margin-bottom: 0 !important;
}

@media only screen and (max-width: 479px) {
  .placement-confirm {
    display: flex;
    flex-wrap: wrap;
    margin: -5px -10px 0 -5px;
  }
  .placement-confirm .pop-confirm {
    flex: 0 0 50%;
  }
  .pop-confirm .ant-btn {
    display: block;
    padding: 0 20px;
    max-width: 80px;
    min-width: 80px;
    margin: 10px;
  }
  .pop-confirm.pop-confirm-right {
    margin-left: 0px !important;
  }
  .pop-confirm.pop-confirm-top {
    margin-left: 0px !important;
  }
  .pop-confirm.pop-confirm-bottom {
    margin-left: 0px !important;
    margin-top: 0px !important;
  }
}

@media only screen and (max-width: 400px) {
  .ant-select {
    width: 100% !important;
  }
  .rdrDefinedRangesWrapper {
    width: 100% !important;
  }
  .rdrDateRangePickerWrapper {
    flex-wrap: wrap;
  }
  .atbd-top-dropdwon {
    width: 280px;
    min-width: 180px;
  }
  .atbd-top-dropdwon .atbd-top-dropdwon__title {
    min-height: 40px;
  }
  .atbd-top-dropdwon .atbd-top-dropdwon__nav li:not(:last-child) {
    margin-bottom: 10px;
  }
  .atbd-top-dropdwon .atbd-top-dropdwon__nav li a {
    padding: 10px 0px;
  }
  .atbd-top-dropdwon .atbd-top-dropdwon__content img {
    margin-right: 15px;
  }
  .atbd-top-dropdwon .atbd-top-dropdwon__content figcaption {
    margin-left: 0;
  }
  .atbd-top-dropdwon .atbd-top-dropdwon__content figcaption .atbd-top-dropdwonText {
    min-width: 155px;
  }
  .ant-drawer-content-wrapper {
    width: 260px !important;
  }
  .rdrCalendarWrapper.rdrDateRangeWrapper {
    margin-top: 0;
  }
}

@media only screen and (max-width: 379px) {
  .ant-card-head-wrapper .ant-card-extra .ant-radio-button-wrapper {
    height: 32px !important;
    line-height: 30px !important;
  }
  .ant-notification-notice {
    width: 275px;
  }
}

@media (max-width: 991px) {
  .mail-sideabr {
    box-shadow: 0 0 10px #00000020;
  }
}

/* Invoice Print Style */
@media print {
  .invoice-area .ant-page-header {
    display: none;
  }
  .customizer-trigger {
    display: none;
  }
}

/* .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
  color: #fff !important;
} */

/* custom label */

/* card spin loader */

.ant-card-body .sd-spin div,
.ant-card-body .spin div {
  position: relative;
}

.ant-card-body .sd-spin,
.ant-card-body .spin {
  height: 200px;
}

.ant-card-body {
  position: relative;
}

.ant-card-body .sd-spin .ant-spin,
.ant-card-body .spin .ant-spin {
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-height: 200px;
}

.starActive svg {
  color: red;
}

/* vectormap zoom in / zoom out */

.jvectormap-zoomin,
.jvectormap-zoomout {
  width: 27px;
  height: 27px;
  background: none;
  color: #5a5f7d;
  border: 1px solid #f1f2f6;
  padding: 0;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: auto;
  right: 0;
  top: auto;
  background-color: #fff;
}

.jvectormap-zoomin {
  border-radius: 6px 6px 0 0;
  bottom: 36px;
}

.jvectormap-zoomout {
  border-radius: 0 0 6px 6px;
  bottom: 10px;
}

.jvectormap-tip {
  padding: 7px 12px;
  border: 0 none;
  font-size: 12px;
  background: #272b41;
}

.btn-rtl {
  width: 60px;
  height: 60px;
  border: 1px solid #fff;
  background: #4347d9;
  color: #fff;
  position: fixed;
  right: 0;
  top: 50%;
  margin-top: -30px;
  z-index: 99999999;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* masonry-grid start from here */

.my-masonry-grid {
  /* Not needed if autoprefixing */
  /* Not needed if autoprefixing */
  display: flex;
  margin-left: -10px;
  /* gutter size offset */
  width: auto;
}

.my-masonry-grid_column {
  padding-left: 10px;
  /* gutter size */
  background-clip: padding-box;
}

/* Style your items */

.my-masonry-grid_column > div {
  /* change div to reference your elements you put in <Masonry> */
  background: grey;
  margin-bottom: 30px;
}

.common-ul {
  padding: 5px 0;
  padding-left: 10px;
}

.display {
  display: none;
}

li.active > .display {
  display: block;
}

/* rtl section from here */
html[dir='rtl'] .ant-card-head-title span {
  margin-right: 15px;
}
html[dir='rtl'] span[aria-label='arrow-right'] svg,
html[dir='rtl'] span[aria-label='arrow-left'] svg {
  transform: rotateY(180deg);
}

html[dir='rtl'] .ant-menu.ant-menu-vertical {
  text-align: right !important;
}

html[dir='rtl'] .ant-menu.ant-menu-vertical .ant-menu-submenu-placement-rightTop {
  left: -170px !important;
}

html[dir='rtl'] .ant-menu.ant-menu-vertical .ant-menu-vertical-left {
  text-align: right;
}

html[dir='rtl'] .ant-menu.ant-menu-vertical .ant-menu-submenu-arrow {
  right: auto;
  left: 16px;
  transform: rotateY(180deg);
}

html[dir='rtl'] .ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 15px !important;
}

/* Auth0 style */
.auth0-lock.auth0-lock .auth0-lock-header-logo {
  width: 180px !important;
  margin: 0 !important;
  display: none !important;
}

.auth0-lock.auth0-lock .auth0-lock-name {
  font-size: 18px !important;
}

.auth0-lock.auth0-lock .auth0-lock-close-button,
.auth0-lock.auth0-lock .auth0-lock-back-button {
  box-shadow: none !important;
  padding: 2px !important;
}
.common-ul {
  padding: 5px 0;
  padding-left: 10px;
}

.display {
  display: none;
}

li.active > .display {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/static/css/style.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA,oBAAoB;;AAEpB;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,uBAAuB;;AAEvB;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;;AAEpB;EACE,sBAAsB;AACxB;;AAEA,aAAa;;AAEb;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,OAAO;EACP,aAAa;AACf;;AAEA,wBAAwB;;AAExB;;EAEE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,SAAS;AACX;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;;AAEV;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;;AAElB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;;AAEpB;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,eAAe;;AAEf;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;;EAME,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gBAAgB;;AAEhB;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;;AAEf;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;;AAEV;EACE,kCAAkC;AACpC;;AAEA,SAAS;;AAET;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;AACzB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;;AAE3B;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,mBAAmB;;AAEnB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;;AAEV;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,WAAW;;AAEX;EACE,2BAA2B;AAC7B;;AAEA,SAAS;;AAET;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,SAAS;;AAET;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,YAAY;;AAEZ;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;;AAEnB;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,wBAAwB;EACxB,YAAY;EACZ,iCAAiC;EACjC,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB;;AAEnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mBAAmB;;AAEnB;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;;AAEnB;EACE,2BAA2B;AAC7B;;AAEA,0BAA0B;;AAE1B;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;;AAEf;EACE,eAAe;AACjB;;AAEA,gBAAgB;;AAEhB;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,eAAe;;AAEf;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA,eAAe;;AAEf;EACE,gCAAgC;AAClC;;AAEA,iBAAiB;;AAEjB;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;;AAEtB;EACE,UAAU;AACZ;;AAEA,kBAAkB;;AAElB;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,qBAAqB;;AAErB;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,qBAAqB;;AAErB;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;;AAErB;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EAGjB,2BAA2B;AAF7B;AAIA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,OAAO;EACP,SAAS;EACT,iCAAiC;EACjC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;;EAOE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;EAME,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;AACA;;;;;;;EAOE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;;AAEf;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;AACf;;AAEA,mBAAmB;;AAEnB;EACE;IACE,yCAAyC;EAC3C;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;EACA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kCAAkC;EACpC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;;;;IAIE,iBAAiB;EACnB;EACA;;;IAGE,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,WAAW;EACb;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;EACA,iBAAiB;EACjB;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,+BAA+B;IAC/B,WAAW;IACX,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;;AAEnB;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,eAAe;IACf,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;;GAEG;;AAEH,iBAAiB;;AAEjB,qBAAqB;;AAErB;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA,iCAAiC;;AAEjC;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iCAAiC;;AAEjC;EAEE,gCAAgC;EAEhC,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,qBAAqB;;AAErB;EACE,+DAA+D;EAC/D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Utilitiy classes */\n\n.spin {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.d-flex {\n  display: flex;\n}\n\n.flex-grid .flex-grid-child {\n  padding: 0 12px;\n}\n\n.align-center-v {\n  display: flex;\n  align-items: center;\n}\n\n.justify-content-between {\n  justify-content: space-between;\n}\n\n.justify-content-center {\n  justify-content: center;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.line-height-0 {\n  line-height: 0;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.status {\n  display: inline !important;\n  font-size: 12px;\n  font-weight: 500;\n  background-color: #868eae10;\n  padding: 4.5px 11.85px;\n  border-radius: 15px;\n}\n\n.status.Success {\n  background-color: #20c99710;\n  color: #20c997;\n}\n\n.status.warning {\n  background-color: #fa8b0c10;\n  color: #fa8b0c;\n}\n\n.status.error {\n  background-color: #ff4d4f10;\n  color: #ff4d4f;\n}\n\nul {\n  list-style: outside none none;\n  margin: 0;\n  padding: 0;\n}\n\n/* spacing classes */\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mb-20 {\n  margin-bottom: 20px !important;\n}\n.mb-25 {\n  margin-bottom: 25px !important;\n}\n.mb-30 {\n  margin-bottom: 30px;\n}\n\n.pb-30 {\n  padding-bottom: 30px;\n}\n\n.pl-0 {\n  padding-left: 0 !important;\n}\n\n.mt-20 {\n  margin-top: 20px !important;\n}\n\n.mt-25 {\n  margin-top: 25px;\n}\n.mt-30 {\n  margin-top: 30px;\n}\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n\n/* default card style */\n\n.ant-card {\n  box-shadow: 0 5px 20px #9299b803;\n}\n\n.ant-card-body {\n  padding: 25px !important;\n}\n\n.ant-card-head {\n  padding-left: 25px !important;\n  padding-right: 25px !important;\n}\n\n.ant-card-head-title span {\n  display: inline-block;\n  margin-left: 15px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #868eae;\n}\n\n.ant-card-head .ant-card-extra {\n  display: flex;\n  align-items: center;\n}\n\n.ant-card-head .ant-card-extra a {\n  color: #868eae;\n}\n\n.ant-card-extra .ant-dropdown-trigger {\n  line-height: 0;\n  order: 1;\n  margin-left: 20px;\n}\n\n.sDash_unresizable {\n  resize: none;\n}\n\n/* ant radio group */\n\n.ant-radio-button-wrapper-checked {\n  color: #fff !important;\n}\n\n/* card nav */\n\n.card-nav ul {\n  list-style: none;\n  display: flex;\n  margin: 0 -8px !important;\n}\n\n.card-nav ul li {\n  margin: 0 8px !important;\n  position: relative;\n}\n\n.card-nav ul li a {\n  font-weight: 500;\n  color: #868eae;\n  font-size: 12px;\n}\n\n.card-nav ul li.active a {\n  color: #5f63f2;\n  font-weight: 500;\n}\n\n.card-nav ul li.active:before {\n  position: absolute;\n  content: '';\n  width: 100%;\n  height: 1px;\n  background: #5f63f2;\n  left: 0;\n  bottom: -19px;\n}\n\n/* chart growth upward */\n\n.growth-downward p,\n.growth-upward p {\n  font-size: 14px;\n  color: #868eae;\n  margin: 0;\n}\n\n.growth-downward h1 sub svg,\n.growth-upward h1 sub svg {\n  position: relative;\n  top: 2px;\n  font-size: 14px;\n  font-weight: 600;\n  left: 5px;\n  bottom: 0;\n}\n\n/*\n.growth-downward h1, .growth-upward h1 {\n  font-size: 22px;\n  margin: 6px 0 0;\n} */\n\n.growth-downward h1 sub {\n  color: #ff4d4f;\n}\n\n.growth-upward h1 sub {\n  color: #20c997;\n}\n\n/* Chart */\n\n.chart-label {\n  display: flex;\n}\n\n.chart-label .chart-label__single {\n  align-items: center;\n}\n\n.chart-label .chart-label__single:not(:last-child) {\n  margin-right: 40px;\n}\n\n.chart-label .chart-label__single p {\n  margin: 0;\n  color: #868eae;\n}\n\n/* revenue doughnut */\n\n.revenue-doughnut {\n  display: flex;\n  justify-content: center;\n}\n\n.revenue-doughnut > div {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.revenue-doughnut .rd-labels {\n  width: 100%;\n  margin-top: 30px;\n}\n\n.revenue-chat-percentage span {\n  display: block;\n}\n\n.revenue-chat-percentage span:not(:last-child) {\n  margin-bottom: 15px;\n}\n\n/* progressbars */\n\n.ant-progress {\n  display: inline-flex !important;\n  align-items: center;\n}\n\n.ant-progress > div {\n  display: flex;\n  flex-direction: column;\n}\n\n.ant-progress .ant-progress-outer {\n  margin-right: 0 !important;\n  padding-right: 0 !important;\n}\n\n.revenue-chat-percentage span {\n  display: block;\n  font-size: 13px;\n  color: #868eae;\n}\n\n.revenue-chat-percentage span:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.ant-progress-status-warning .ant-progress-bg {\n  background: #fa8b0c;\n}\n\n/* progress bars */\n\n.progress-primary .ant-progress-bg {\n  background: #5f63f2;\n}\n\n.progress-secondary .ant-progress-bg {\n  background: #ff69a5;\n}\n\n.progress-success .ant-progress-bg {\n  background: #20c997;\n}\n\n.progress-success .progress-info .ant-progress-bg {\n  background: #2c99ff;\n}\n\n.progress-warning .ant-progress-bg {\n  background: #fa8b0c;\n}\n\n.progress-danger .ant-progress-bg {\n  background: #ff4d4f;\n}\n\n/* color classes */\n\n.color-primary {\n  color: #5f63f2;\n}\n\n.color-secondary {\n  color: #ff69a5;\n}\n\n.color-info {\n  color: #2c99ff;\n}\n\n.color-warning {\n  color: #fa8b0c;\n}\n\n.color-success {\n  color: #20c997;\n}\n\n.color-danger {\n  color: #ff4d4f;\n}\n\n.color-dark {\n  color: #272b41;\n}\n\n.color-error {\n  color: #f5222d;\n}\n\n.color-gray {\n  color: #5a5f7d;\n}\n\n/* Button Styles */\n\n.ant-btn.ant-btn-light:focus {\n  background: #fff;\n  color: #5a5f7d;\n}\n\n.button-example .ant-btn {\n  margin: 4px;\n}\n\n.button-example .ant-btn-group .ant-btn {\n  margin: 0;\n}\n\n.ant-btn-white {\n  color: #5a5f7d !important;\n  border-color: #e3e6ef !important;\n}\n\n.ant-btn-white:hover {\n  color: #5f63f2 !important;\n  background-color: #fff !important;\n  border-color: #fff;\n}\n\n.ant-btn-white:focus {\n  background-color: transparent !important;\n}\n\n.ant-btn-link {\n  background-color: #fff;\n  border-color: #fff;\n  color: #5f63f2;\n}\n\n.ant-btn-link:hover {\n  border-color: #fff;\n  background: #fff;\n}\n\n.ant-btn-light,\n.ant-btn-light:hover,\n.ant-btn-link:hover,\n.ant-btn-dashed {\n  color: #5a5f7d !important;\n}\n\n.ant-btn-light {\n  border-color: #e3e6ef;\n  background: #f4f5f7 !important;\n}\n\n.ant-btn-light.btn-outlined {\n  background: transparent !important;\n}\n\n.ant-btn-light.btn-transparent {\n  background: #f4f5f715;\n}\n\n.ant-btn-dashed {\n  border-width: 1px !important;\n}\n\n.ant-btn-dashed:hover {\n  color: #5f63f2;\n  border: 1px dashed #5f63f2;\n}\n\n.ant-btn-primary[disabled] {\n  color: #fff;\n  background: #5f63f260;\n}\n\n.ant-btn-light[disabled] {\n  background: #fff;\n}\n\n.ant-btn-round.ant-btn-sm {\n  height: 38px;\n}\n\n.ant-btn-white[disabled] {\n  background-color: transparent;\n  opacity: 0.6;\n}\n\n.ant-btn-white[disabled]:hover {\n  color: #5a5f7d !important;\n}\n\n.ant-btn-primary[disabled]:hover {\n  color: #fff !important;\n  background: #5f63f260 !important;\n}\n\n.btn-icon {\n  padding: 0 13px;\n}\n\n.btn-inc,\n.btn-dec {\n  height: 38px;\n  width: 38px;\n  font-size: 20px;\n  padding: 0 12px !important;\n  border-radius: 10px !important;\n  border: 0 none;\n}\n\n.btn-inc:hover,\n.btn-dec:hover {\n  background: #5f63f210 !important;\n  border: 0 none !important;\n}\n\n.btn-inc:hover i,\n.btn-inc:hover svg,\n.btn-dec:hover i,\n.btn-dec:hover svg {\n  color: #5f63f2;\n}\n\n/* input styles */\n\n.ant-form-item-label > label {\n  font-weight: 500;\n}\n\n.ant-picker-input > input::placeholder {\n  color: #adb4d2 !important;\n}\n\n/* Calendar Styles */\n\n.ant-picker-calendar-header .ant-select-selector {\n  height: 32px !important;\n}\n\n.ant-picker-calendar-header .ant-select-selection-search-input {\n  height: 30px !important;\n}\n\n.ant-select-single .ant-select-selector .ant-select-selection-item {\n  line-height: 30px !important;\n}\n\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  background: #fff !important;\n  color: #5f63f2 !important;\n}\n\n/* pagination */\n\n.ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  height: 32px !important;\n}\n\n.ant-pagination-item-active {\n  background-color: #5f63f2 !important;\n}\n\n.ant-pagination-item-active a {\n  color: #fff !important;\n}\n\n.ant-pagination .ant-pagination-options .ant-select-selection-item {\n  font-size: 13px;\n  line-height: 30px !important;\n}\n\n.ant-pagination .ant-pagination-options .ant-pagination-options-quick-jumper {\n  height: 30px;\n  line-height: 30px;\n}\n\n.ant-pagination .ant-pagination-options .ant-pagination-options-quick-jumper input {\n  line-height: 30px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.ant-pagination .ant-pagination-prev,\n.ant-pagination .ant-pagination-next,\n.ant-pagination .ant-pagination-jump-prev,\n.ant-pagination .ant-pagination-jump-next,\n.ant-pagination .ant-pagination-item,\n.ant-pagination .ant-pagination-options .ant-select-selector {\n  border: 1px solid #f1f2f6 !important;\n  background-color: #fff;\n}\n\n.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-ellipsis,\n.ant-pagination .ant-pagination-jump-next .ant-pagination-item-ellipsis {\n  color: #5a5f7d !important;\n  line-height: 2.6;\n}\n\n.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-link,\n.ant-pagination .ant-pagination-jump-next .ant-pagination-item-link {\n  display: block;\n}\n\n.ant-pagination-prev,\n.ant-pagination-next {\n  line-height: 28px !important;\n}\n\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n  border: 0 none !important;\n}\n\n.ant-pagination .ant-pagination-item a {\n  color: #5a5f7d;\n}\n\n.ant-pagination .ant-select-single .ant-select-selector .ant-select-selection-item {\n  line-height: 30px !important;\n  color: #5a5f7d;\n}\n\n.ant-pagination\n  .ant-select-single:not(.ant-select-customize-input)\n  .ant-select-selector\n  .ant-select-selection-search-input {\n  height: 100% !important;\n}\n\n.ant-pagination {\n  margin: -4px -12px !important;\n}\n\n.ant-pagination-item,\n.ant-pagination-options,\n.ant-pagination-prev,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next,\n.ant-pagination-next {\n  margin: 4px !important;\n}\n\n.ant-table-pagination {\n  margin-top: 30px !important;\n}\n\n/* Wizard Modal */\n.submission-successModal {\n  text-align: center;\n}\n.submission-successModal .icon-success {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  border: 1px solid #20c997;\n}\n.submission-successModal p {\n  margin-bottom: 0;\n}\n.submission-successModal .icon-success svg {\n  color: #20c997;\n}\n.submission-successModal .submission-action {\n  margin: 30px -5px -5px -5px;\n}\n.submission-successModal .submission-action button {\n  margin: 5px;\n  height: 38px;\n}\n\n/* Tree Select */\n\n.ant-tree-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  height: 42px !important;\n  line-height: 40px;\n}\n\n.ant-tree-select.ant-select-single:not(.ant-select-customize-input)\n  .ant-select-selector\n  .ant-select-selection-search-input {\n  height: 100% !important;\n}\n\n.ant-tree-select.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 40px !important;\n}\n\n/* radio style */\n\n.ant-radio-checked .ant-radio-inner {\n  border-width: 5px !important;\n}\n\n.ant-radio-inner::after {\n  content: none !important;\n}\n\n/* Statistics */\n\n.ant-statistic .ant-statistic-title {\n  color: #9299b8;\n}\n\n.ant-statistic .ant-statistic-content span {\n  font-size: 20px;\n}\n\n/* Steps */\n\n.steps-action.justify-content-center {\n  justify-content: center !important;\n}\n\n/* rate */\n\n.ant-rate-star.ant-rate-star-zero span svg {\n  color: #c6d0dc;\n}\n\n.ant-rate-star:not(:last-child) {\n  margin-right: 2px !important;\n}\n\n.ant-rate-text {\n  color: #5a5f7d;\n}\n\n/* result */\n\n.ant-result-icon {\n  margin-bottom: 20px !important;\n}\n\n.ant-result-title {\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.ant-result-extra {\n  height: 34px;\n  padding: 4px 10.72px;\n}\n\n.ant-result-content .ant-typography strong {\n  font-weight: 500;\n}\n\n.ant-result-content .ant-typography:last-child {\n  margin-bottom: 0;\n}\n\n/* form select */\n\n.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  height: 38px !important;\n}\n\n.ant-select-single .ant-select-selector .ant-select-selection-item,\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 33px !important;\n}\n\n.ant-select-multiple .ant-select-selector {\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n}\n\n.sDash_fullwidth-select {\n  width: 100%;\n}\n\n/* Nasted Comments Styles */\n\n.nested-comment-wrapper .comment-title {\n  font-size: 12px;\n  padding-bottom: 10px;\n  margin-bottom: 22px;\n  border-bottom: 1px solid #e3e6ef;\n}\n\n/* calendar style */\n\n.events {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.events .ant-badge-status {\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  text-overflow: ellipsis;\n  font-size: 12px;\n}\n\n.notes-month {\n  text-align: center;\n  font-size: 28px;\n}\n\n.notes-month section {\n  font-size: 28px;\n}\n\n/* Breadcrumb demo */\n\n.demo {\n  margin: 16px;\n}\n\n.demo-nav {\n  height: 30px;\n  line-height: 30px;\n  margin-bottom: 16px;\n  background: #f8f8f8;\n}\n\n.demo-nav a {\n  line-height: 30px;\n  padding: 0 8px;\n}\n\n.app-list {\n  margin-top: 16px;\n}\n\n/* Modal */\n\n.ant-modal .ant-modal-content {\n  border-radius: 10px;\n}\n\n.ant-modal .ant-modal-header {\n  border-radius: 10px 10px 0 0;\n}\n\n.ant-modal-body p:last-child {\n  margin-bottom: 0;\n}\n\n.project-modal {\n  padding: 5px !important;\n}\n\n.project-modal .projects-members {\n  margin-top: -12px;\n}\n\n.project-modal .ant-form-item-control-input {\n  margin-top: 10px;\n  min-height: auto;\n}\n\n.project-modal .ant-select-selector {\n  border-color: #e3e6ef;\n}\n\n.project-modal-footer {\n  padding: 10px !important;\n  text-align: left !important;\n}\n\n.sDash_addTask-modal {\n  max-width: 390px;\n}\n.sDash_addTask-modal .ant-modal-header {\n  border-bottom: 0 none;\n  padding-bottom: 0 !important;\n}\n.sDash_addTask-modal .ant-modal-header .ant-modal-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #272b41;\n}\n.sDash_addTask-modal .sDash_addTask-modal-inner .ant-form-item {\n  margin-bottom: 15px;\n}\n.sDash_addTask-modal .ant-modal-header .ant-modal-close-x svg {\n  color: #9299b8;\n}\n.sDash_addTask-modal .ant-form-item-control-input {\n  min-height: 36px;\n}\n.sDash_addTask-modal input::placeholder,\n.sDash_addTask-modal textarea::placeholder {\n  color: #9299b8;\n}\n.sDash_addTask-modal input,\n.sDash_addTask-modal textarea {\n  padding: 6px 20px;\n  border-radius: 5px;\n}\n.sDash_addTask-modal textarea {\n  resize: none;\n  min-height: 125px;\n}\n.sDash_addTask-modal .sDash-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin: -6px;\n}\n.sDash_addTask-modal .sDash-modal-actions button {\n  font-size: 14px;\n  margin: 6px;\n  height: 38px;\n  border-radius: 5px;\n}\n/* slider */\n\n.ant-slider-handle {\n  margin-top: -6px !important;\n}\n\n/* tags */\n\n.ant-tag {\n  font-weight: 600;\n  padding: 0 9.5px;\n}\n\n/* tabs */\n\n.ant-tabs-tab span {\n  display: flex;\n  align-items: center;\n}\n\n/* list */\n\n.ant-list-bordered {\n  border-color: #e3e6ef !important;\n}\n\n.ant-list-item-meta {\n  padding: 10px 24px;\n  border-bottom: 1px solid #f1f2f6;\n}\n\n/* popover */\n\n.ant-popover {\n  position: fixed;\n  z-index: 99999;\n}\n\n.ant-popover-inner {\n  padding: 15px;\n  box-shadow: 0 5px 20px #9299b820;\n  border-radius: 0 0 6px 6px;\n}\n\n.ant-popover-inner .ant-popover-title {\n  padding: 5px 10px 10px;\n}\n\n.ant-popover-inner .ant-popover-inner-content a {\n  color: #5a5f7d;\n}\n\n/* Drawer */\n\n.ant-drawer {\n  z-index: 99999;\n}\n\n/* Select Dropdwon */\n\n.ant-select-dropdown {\n  padding: 18px 0 !important;\n  box-shadow: 0 5px 20px #9299b820 !important;\n  border-radius: 0 0 6px 6px !important;\n}\n\n.ant-select-item {\n  min-height: 20px !important;\n  padding: 4px 12px !important;\n}\n\n.ant-select-item-group {\n  color: #9299b8;\n}\n\n.ant-select-item.ant-select-item-option-grouped {\n  padding-left: 25px !important;\n}\n\n.ant-select-dropdown .ant-select-item.ant-select-item-option-active {\n  background: #5f63f205;\n}\n\n.ant-select-dropdown .ant-select-item.ant-select-item-option-selected .ant-select-item-option-content {\n  padding-left: 10px;\n}\n\n.ant-select-dropdown .ant-select-item.ant-select-item-option-selected {\n  color: #5f63f2;\n  background: #5f63f206;\n}\n\n.ant-select-dropdown .ant-select-item.ant-select-item-option-selected .ant-select-item-option-content {\n  color: #5f63f2;\n  font-weight: 500;\n}\n\n.ant-select-dropdown .ant-select-item .ant-select-item-option-content {\n  transition: 0.3s;\n  color: #5a5f7d;\n}\n\n/* mail props dropdown */\n\n.mail-props {\n  padding: 5px 25px;\n  border: 0 none;\n  background: #fff;\n  /* box-shadow: 0 5px 40px rgba(146, 153, 184, 0.25); */\n}\n\n.mail-props li {\n  display: flex;\n  margin-bottom: 12px;\n}\n\n.mail-props li span:first-child {\n  margin-right: 50px;\n  min-width: 40px;\n}\n\n.mail-props li span:last-child {\n  color: #5a5f7d;\n}\n\n.mail-props li:last-child {\n  margin-bottom: 0;\n}\n\n.mail-props li span {\n  color: #9299b8;\n}\n\n/* Basic Dropdwon */\n\n.ant-dropdown {\n  box-shadow: 0 5px 30px #9299b820 !important;\n}\n\n.ant-dropdown.wide-dropdwon {\n  min-width: 140px !important;\n}\n\n.ant-dropdown.wide-dropdwon.kanbanCard-more {\n  min-width: 220px !important;\n  box-shadow: 0 17px 20px #9299b820;\n}\n.ant-dropdown.wide-dropdwon.kanbanCard-more a {\n  padding: 10px 24px;\n}\n\n.ant-dropdown-menu {\n  min-width: 200px;\n  border-radius: 0 0 5px 5px;\n  box-shadow: 0 0;\n}\n\n.ant-dropdown-menu li {\n  color: #5a5f7d;\n  padding: 5px 25px;\n}\n\n.ant-dropdown-menu li:hover {\n  background-color: #5f63f205;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__title {\n  background: #f4f5f7;\n  width: 100%;\n  margin-bottom: 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  min-height: 50px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.atbd-top-dropdwon {\n  width: 340px;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav {\n  height: 260px;\n  overflow: hidden;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav.notification-list {\n  padding: 0 10px;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav li {\n  width: 100%;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav li a {\n  padding: 13px 10px;\n  position: relative;\n  width: 100%;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav li:last-child {\n  margin: 0;\n}\n\n.atbd-top-dropdwon a.btn-seeAll {\n  position: relative;\n  width: calc(100% + 30px);\n  left: -15px;\n  right: -15px;\n  height: calc(100% + 15px);\n  bottom: -15px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 500;\n  color: #5f63f2;\n  padding: 15px 0;\n  border-radius: 0 0 6px 6px;\n  background: #fff;\n}\n\n.atbd-top-dropdwon a.btn-seeAll:before {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 -15px 20px #9299b808;\n  z-index: 1;\n  content: '';\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav li a.btn-seeAll:hover:after {\n  box-shadow: 0 0;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav li a:hover {\n  background: #fff;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav li a:hover:after {\n  opacity: 1;\n  visibility: visible;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__nav li a:after {\n  position: absolute;\n  left: -15px;\n  right: -15px;\n  top: 0;\n  width: calc(100% + 30px);\n  height: 100%;\n  box-shadow: 0 15px 50px #9299b820;\n  z-index: 1;\n  content: '';\n  opacity: 0;\n  visibility: hidden;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 0;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-icon {\n  width: 39.2px;\n  height: 32px;\n  margin-right: 15px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-icon.bg-primary {\n  background: #5f63f215;\n  color: #5f63f2;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-icon.bg-secondary {\n  background: #ff69a515;\n  color: #ff69a5;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content .notification-content {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.atbd-top-dropdwon .notification-text h1 {\n  font-size: 14px;\n  font-weight: 400;\n  color: #5a5f7d;\n  margin-bottom: 4px;\n}\n\n.atbd-top-dropdwon .notification-text h1 span {\n  color: #5f63f2;\n  font-weight: 500;\n  padding-left: 0;\n}\n\n.atbd-top-dropdwon .notification-text p {\n  font-size: 12px;\n  color: #adb4d2;\n  margin-bottom: 0;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content img {\n  max-width: 40px;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption {\n  margin: -4px 15px 0;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption .ant-badge-count {\n  font-size: 8px;\n  min-width: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 6px;\n  border-radius: 8px;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption p.ant-scroll-number-only-unit.current {\n  height: 15px;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption h1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption h1 span {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.atbd-top-dropdwon .atbd-top-dropdwon__content figcaption p {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n}\n\n.add-file-dropdown a {\n  font-size: 14px;\n  font-weight: 400;\n}\n.add-file-dropdown a svg {\n  width: 14px;\n}\n\n.folder-dropdown {\n  min-width: 200px !important;\n}\n\n/* Tooltip Styles */\n\n.ant-tooltip .ant-tooltip-inner {\n  min-height: 40px;\n  padding: 6px 20px;\n  font-size: 14px;\n  color: #5a5f7d;\n  background-color: #fff;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  border: 1px solid #f1f2f6;\n  box-shadow: 0 8px 15px #9299b815;\n}\n\n.ant-tooltip .ant-tooltip-arrow {\n  /* position: relative; */\n}\n\n.ant-tooltip .ant-tooltip-arrow:after {\n  position: absolute;\n  left: 50%;\n  top: 12px;\n  transform: translateX(-50%);\n  width: 13px;\n  height: 13px;\n  background: #fff;\n  content: '';\n}\n\n.ant-tooltip .ant-tooltip-arrow .ant-tooltip-arrow-content {\n  width: 10px;\n  height: 10px;\n  background: #fff;\n}\n\n.ant-tooltip-placement-bottom .ant-tooltip-arrow .ant-tooltip-arrow-content {\n  border: 1px solid #f1f2f6;\n  box-shadow: 0 0;\n}\n\n.ant-tooltip-placement-bottom .ant-tooltip-arrow {\n  top: -4.071068px;\n}\n\n/* Badge Styles */\n\n.ant-badge.badge-success .ant-badge-count {\n  background: #20c997;\n}\n\n.badge {\n  font-size: 11px;\n  font-weight: 500;\n  padding: 0 6.5px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n}\n\n.badge.badge-primary {\n  background: #5f63f210;\n  color: #5f63f2;\n}\n\n/* Cascade Styles */\n\n.custom-cascade-render .ant-cascader-picker {\n  width: 100%;\n}\n\n.ant-cascader-picker input::placeholder {\n  color: #adb4d2;\n}\n\n/* Comment Styles */\n\n.ant-comment-actions li {\n  margin-bottom: 0 !important;\n}\n\n/* Radio Vertical Button */\n\n.ant-radio-vertical .ant-radio-wrapper {\n  display: block;\n}\n\n.ant-radio-vertical .ant-radio-wrapper:not(:last-child) {\n  margin-bottom: 14px;\n}\n\n/* Select Tree */\n\n.ant-select-tree-list .ant-select-tree-node-content-wrapper:hover {\n  background-color: #bae7ff !important;\n}\n\n.ant-select-tree-list .ant-select-arrow svg {\n  font-size: 10px;\n}\n\n.ant-tree-select.ant-select-multiple .ant-select-selection-item {\n  border: 0 none;\n  border-radius: 3px;\n  background: #f4f5f7;\n  color: #5a5f7d;\n  font-weight: 500;\n}\n\n/* Ant Switch */\n\n.ant-switch:after {\n  width: 14px !important;\n  height: 14px !important;\n}\n\n.ant-switch-small:after {\n  width: 10px !important;\n  height: 10px !important;\n}\n\n/* Time Picker */\n\n.ant-picker {\n  min-width: 250px;\n}\n\n/* Input Affix */\n\n.ant-input-affix-wrapper > input.ant-input {\n  padding-left: 5px;\n}\n\n.ant-input-affix-wrapper .ant-input-prefix svg {\n  color: #e3e6ef;\n}\n\n/* Space Item */\n\n.ant-space-item .ant-btn span {\n  font-size: 14px;\n}\n\n/* Pop confirm */\n\n.pop-confirm .ant-btn {\n  max-width: 90px;\n  padding: 0px 35.5px;\n  height: 44px;\n}\n\n.pop-confirm-top {\n  margin-bottom: 10px;\n}\n\n.pop-confirm-bottom {\n  margin-top: 10px;\n}\n\n.pop-confirm-top .ant-btn:not(:last-child),\n.pop-confirm-bottom .ant-btn:not(:last-child) {\n  margin-right: 10px;\n}\n\n.pop-confirm-left .ant-btn:not(:last-child),\n.pop-confirm-right .ant-btn:not(:last-child) {\n  margin-bottom: 10px;\n}\n\n/* Ant Upload */\n\n.ant-upload .ant-btn {\n  font-size: 14px;\n  border-radius: 5px;\n}\n\n.ant-upload.ant-upload-select-picture-card {\n  border-color: #e3e6ef !important;\n  border-radius: 5px !important;\n  background-color: #f8f9fb !important;\n}\n\n.ant-upload.ant-upload-select-picture-card .anticon {\n  margin-bottom: 8px;\n}\n\n.ant-upload .anticon svg {\n  color: #9299b8;\n}\n\n.ant-upload-list {\n  margin-top: 10px !important;\n}\n\n.sDash_upload-basic .ant-upload.ant-upload-select {\n  width: 100%;\n  border: 1px solid #e3e6ef;\n  border-radius: 4px;\n}\n.sDash_upload-basic .ant-upload.ant-upload-select .ant-upload {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.sDash_upload-basic .sDash_upload-text {\n  font-size: 14px;\n  color: #9299b8;\n  padding-left: 15px;\n}\nhtml[dir='rtl'] .sDash_upload-basic .sDash_upload-text {\n  padding-left: 0px;\n  padding-right: 15px;\n}\n.sDash_upload-basic .sDash_upload-browse {\n  font-size: 14px;\n  color: #9299b8;\n  display: inline-block;\n  padding: 14px 23px;\n  border-left: 1px solid #e3e6ef;\n}\nhtml[dir='rtl'] .sDash_upload-basic .sDash_upload-browse {\n  border-left: 0 none;\n  border-right: 1px solid #e3e6ef;\n}\n.ant-card.sDash_upload-form .ant-card-body {\n  padding-bottom: 15px !important;\n}\n/* Ant Picker */\n\n.ant-picker {\n  border-color: #e3e6ef !important;\n}\n\n/* Ant Dropdown */\n\n.ant-dropdown {\n  box-shadow: 0 5px 20px #9299b820;\n  background: #fff;\n  border-radius: 6px;\n  padding: 15px 0 !important;\n  border: 0 none;\n}\n\n.ant-dropdown a {\n  display: flex;\n  align-items: center;\n  padding: 8px 24px;\n  font-weight: 400;\n  color: #5a5f7d;\n}\n\n.ant-dropdown a i,\n.ant-dropdown a svg,\n.ant-dropdown a img {\n  margin-right: 8px;\n}\n\n.ant-dropdown div {\n  box-shadow: 0 0;\n  border-radius: 5px;\n}\n\n/* Picker Under Input */\n\n.ant-form-item-control-input .ant-picker {\n  padding: 0 12px 0 0;\n}\n\n/* Leaflet COntainer */\n\n.leaflet-container {\n  z-index: 0;\n}\n\n/* Table Bordered*/\n\n.table-bordered .ant-table-tbody > tr.ant-table-row:hover > td {\n  background: #f8f9fb !important;\n}\n\n.table-bordered .ant-table-thead > tr > th {\n  background: #fff;\n  border-top: 1px solid #f1f2f6;\n}\n\n.table-bordered .ant-table-tbody > tr > td {\n  border-color: #f1f2f6 !important;\n}\n\n.table-bordered .ant-table-thead tr th,\n.table-bordered .ant-table-tbody tr td {\n  padding: 16px 25px;\n}\n\n.table-bordered .ant-table-thead tr th:last-child,\n.table-bordered .ant-table-tbody tr td:last-child {\n  text-align: right;\n}\n\n/* Full Width Table */\n\n.full-width-table .ant-card-body {\n  padding: 0 !important;\n}\n\n.full-width-table .ant-table {\n  border-radius: 10px !important;\n}\n\n.full-width-table .top-seller-table {\n  min-height: 406px;\n}\n\n.full-width-table .top-seller-table .ant-table-content .ant-table-cell {\n  white-space: normal;\n  padding: 16px 15px;\n}\n\n.full-width-table .top-seller-table .ant-table-content .ant-table-cell:first-child {\n  padding-left: 25px;\n}\n\n.full-width-table .top-seller-table .ant-table-content .ant-table-cell:last-child {\n  padding-right: 25px;\n}\n\n.full-width-table .top-seller-table th {\n  text-align: right;\n  color: #272b41;\n  font-weight: 500;\n}\n\n.full-width-table .top-seller-table td {\n  color: #5a5f7d;\n}\n\n.full-width-table .top-seller-table .ant-table-tbody > tr > td {\n  text-align: right;\n}\n\n.full-width-table .top-seller-table th:first-child,\n.full-width-table .top-seller-table td:first-child {\n  text-align: left !important;\n}\n\n/* Table Responsive */\n\n.table-responsive .ant-table-content {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n}\n\n.table-responsive .ant-table-content .ant-table-cell {\n  white-space: nowrap;\n}\n\n/* Rich TextEditor  */\n\n.RichTextEditor__root___2QXK- {\n  border: 0 none !important;\n}\n\n.RichTextEditor__root___2QXK- .EditorToolbar__root___3_Aqz {\n  margin: 0;\n  border-color: #f1f2f6;\n}\n\n.RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button {\n  padding: 0;\n  border: 0 none;\n  background: #fff;\n  margin-right: 8px;\n}\n\n.RichTextEditor__root___2QXK- .Dropdown__root___3ALmx .Dropdown__value___34Py9 {\n  border: 0 none;\n}\n\n.RichTextEditor__root___2QXK- .Dropdown__root___3ALmx select {\n  border-right-width: 0px;\n}\n\n.RichTextEditor__editor___1QqIU .DraftEditor-editorContainer {\n  border: 0 none;\n}\n\n/* ChatBox Dropdwon */\n\n.atbd-chatbox__messageControl {\n  min-width: 210px;\n}\n\n.atbd-chatbox__messageControl ul li a {\n  padding: 4px 24px;\n}\n\n.atbd-chatbox__emoji {\n  margin: -4.48px 0;\n  padding: 0 10px;\n}\n\n.atbd-chatbox__emoji ul {\n  display: flex;\n  align-items: center;\n}\n\n.atbd-chatbox__emoji ul li {\n  display: inline-block;\n}\n\n.atbd-chatbox__emoji ul li a {\n  display: block;\n  font-size: 20px;\n  padding: 4px 7px;\n  background: #fff;\n}\n\n.atbd-chatbox__emoji ul li a:hover {\n  background-color: transparent;\n}\n\n.atbd-chatbox__emoji ul li a svg {\n  margin: 0;\n}\n\n.rdrMonths {\n  flex-wrap: wrap;\n}\n\n.ant-space {\n  flex-wrap: wrap;\n}\n\n.ant-menu .ant-menu-submenu .ant-menu-submenu-title {\n  display: flex;\n  align-items: center;\n}\n\n.ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title,\n.ant-menu-item {\n  display: inline-flex;\n}\n\n.ant-menu-submenu-popup {\n  z-index: 105;\n}\n\n.ant-menu-submenu-popup .ant-menu-sub {\n  padding: 8px 0;\n}\n\n.ant-menu-submenu-popup .ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title,\n.ant-menu-submenu-popup .ant-menu-item {\n  display: block;\n}\n\n.ant-menu-submenu-popup .ant-menu-item {\n  margin-bottom: 0 !important;\n}\n.ant-menu-sub.ant-menu-vertical {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n.ant-menu-sub.ant-menu-vertical .ant-menu-item a {\n  color: #5a5f7d;\n}\n\n/* page heading */\n\n.ant-page-header {\n  padding: 26px 30px 26px 30px !important;\n}\n\n.ant-page-header.header-boxed {\n  padding: 26px 180px 26px 180px !important;\n}\n\n.ant-page-header-heading {\n  align-items: center;\n}\n\n.ant-page-header-heading-title {\n  text-transform: capitalize;\n}\n\n/* Antd drag & drop */\n\n.row-dragging {\n  /* background: #fafafa; */\n  /* border: 1px solid #ccc; */\n  box-shadow: 0 15px 50px #9299b820;\n  display: flex;\n}\n\n.row-dragging tr {\n  box-shadow: 0 15px 50px #9299b820;\n}\n\n.row-dragging td {\n  padding: 16px;\n  color: #000;\n  position: relative;\n  z-index: 9999;\n  opacity: 0.5;\n  vertical-align: middle;\n}\n\n.row-dragging td .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #20c997;\n  border-color: #20c997;\n}\n\n.row-dragging td .todos-action,\n.row-dragging td .table-actions {\n  display: none;\n}\n\n.row-dragging td .user-info figcaption {\n  display: none;\n}\n\n.row-dragging td .feather-move,\n.row-dragging td .drag_email,\n.row-dragging td .drag_company,\n.row-dragging td .drag_designation,\n.row-dragging td .drag_join-date,\n.row-dragging td .active {\n  display: inline-block;\n  margin-top: 10px;\n}\n\n.row-dragging .drag-visible {\n  visibility: visible;\n}\n\n/* File Export Import Modal */\n.sDash_export-wrap .ant-modal {\n  width: 390px !important;\n}\n.sDash_export-wrap .ant-modal .ant-modal-header {\n  border-bottom: 0 none;\n  padding: 18px 30px 0 30px;\n}\n.sDash_export-wrap .ant-modal .ant-modal-body {\n  padding: 25px 30px 30px 30px;\n}\n.sDash_export-wrap .ant-modal .sDash-button-grp {\n  text-align: right;\n}\n.sDash_export-wrap .ant-modal .sDash-button-grp {\n  margin: 20px -8px -8px -8px;\n}\n.sDash_export-wrap .ant-modal .sDash-button-grp button {\n  font-size: 14px;\n  font-weight: 500;\n  text-align: right;\n  height: 40px;\n  padding: 0 16px;\n  margin: 8px;\n}\n.sDash_export-wrap .ant-modal .sDash-button-grp button.ant-btn-white {\n  color: #9299b8 !important;\n}\n.sDash_export-wrap .ant-form-item-control-input {\n  min-height: 36px;\n}\n\n.sDash_export-wrap .ant-form-item-control-input input {\n  font-size: 14px;\n  font-weight: 400;\n  padding: 6px 20px;\n  border-radius: 5px;\n  color: #9299b8;\n}\n\n.sDash_export-wrap .ant-select-single {\n  width: 100% !important;\n}\n\n.sDash_export-wrap .ant-form .ant-form-item {\n  margin-bottom: 15px;\n}\n\n.sDash_export-wrap .ant-select-single .ant-select-selector {\n  padding: 0 20px;\n  border-color: #e3e6ef !important;\n}\n\n.sDash_create-file .sDash-button-grp {\n  text-align: right;\n}\n\n.sDash_create-file .ant-modal {\n  width: 390px !important;\n}\n.sDash_create-file .ant-modal .ant-form-item {\n  margin-bottom: 20px;\n}\n.sDash_create-file .ant-modal-header {\n  border-bottom: 0 none;\n  padding-bottom: 6px;\n}\n.sDash_create-file .sDash-button-grp button {\n  height: 40px;\n  border-radius: 5px;\n  margin: 5px;\n}\n\n.sDash_create-file .ant-form-item-control-input {\n  border-radius: 5px;\n}\n\n.sDash_create-file .ant-form-item-control-input input {\n  border: 1px solid #e3e6ef;\n}\n\n/* Task Modal */\n.sDash_task-details .ant-modal-content .ant-modal-close {\n  top: 10px;\n}\n.sDash_task-details .ant-modal-header {\n  border-bottom: 0 none;\n  padding: 30px 30px 0;\n}\n.sDash_task-details .ant-modal {\n  width: 600px !important;\n}\n.sDash_task-details .ant-modal-header .ant-modal-title h4 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #272b41;\n  margin-bottom: 4px;\n}\n.sDash_task-details .ant-modal-header .ant-modal-title .sub-text {\n  font-size: 14px;\n  font-weight: 400;\n  color: #868eae;\n}\n.sDash_task-details .sDash_task-details-modal .sDash_task-details__label {\n  font-size: 16px;\n  display: block;\n  margin-bottom: 8px;\n}\n.sDash_task-details .sDash_task-details-modal .sDash_task-details-modal__description textarea {\n  padding: 10px 20px;\n  min-height: 88px;\n  width: 100%;\n  border: 0 none;\n  border-radius: 4px;\n  background-color: #f4f5f7;\n  resize: none;\n}\n.sDash_task-details .sDash_task-details-modal .sDash_task-details-modal__description textarea:focus {\n  outline: none;\n}\n.sDash_task-details .sDash_task-details-modal .sDash_task-details-modal__description textarea::placeholder {\n  color: #5a5f7d;\n  font-size: 15px;\n}\n.sDash_task-details .ant-modal-body {\n  padding: 14px 30px 30px 30px;\n}\n.sDash_task-details .ant-modal-body .sDash_checklist-block {\n  margin-top: 26px;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-wrap {\n  position: relative;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form {\n  position: absolute;\n  width: 240px;\n  padding: 18px;\n  left: 0;\n  top: 50px;\n  box-shadow: 0 15px 30px #9299bb30;\n  background-color: #fff;\n  border: 1px solid #e3e6ef;\n  border-radius: 6px;\n  z-index: 222;\n}\n\nhtml[dir='rtl'] .sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form {\n  left: auto;\n  right: 0;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .add-checklist {\n  padding: 10px;\n  border-radius: 4px;\n  background-color: #fff;\n  width: 100%;\n  height: 38px;\n  border: 1px solid #e3e6ef;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .addChecklist-form-action {\n  margin-top: 15px;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .addChecklist-form-action a {\n  position: relative;\n  top: 3px;\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n}\n.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .addChecklist-form-action a svg {\n  color: #9299bb;\n}\n.sDash_task-details .ant-modal-body .sDash_checklist-block .addChecklist-form .addChecklist-form-action .btn-add {\n  margin-right: 15px;\n}\nhtml[dir='rtl']\n  .sDash_task-details\n  .ant-modal-body\n  .sDash_checklist-block\n  .addChecklist-form\n  .addChecklist-form-action\n  .btn-add {\n  margin-left: 15px;\n  margin-right: 0;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-block button {\n  height: 38px;\n  padding: 0px 18.37px;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-row {\n  margin-top: 26px;\n}\n.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist-item:not(:last-child) {\n  margin-bottom: 30px;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist-item__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist-item__top button {\n  padding: 0px 16.32px;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist-item__title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #272b41;\n  margin-bottom: 0;\n}\n\n.sDash_task-details\n  .ant-modal-body\n  .sDash_checklist-row\n  .sDash_checklist__progress\n  .ant-progress-inner\n  .ant-progress-bg {\n  height: 5px !important;\n  background-color: #20c997;\n}\n.sDash_task-details .ant-modal-body .sDash_checklist-row .sDash_checklist__progress .ant-progress .ant-progress-text {\n  font-size: 12px;\n  font-weight: 500;\n  order: -1;\n  margin: 0 10px 0 0;\n}\nhtml[dir='rtl']\n  .sDash_task-details\n  .ant-modal-body\n  .sDash_checklist-row\n  .sDash_checklist__progress\n  .ant-progress\n  .ant-progress-text {\n  margin: 0 0 0 10px;\n}\n.sDash_task-details .ant-modal-body .sDash_checklist-tasks {\n  margin: 5px 0 5px 0;\n}\n.sDash_task-details .ant-modal-body .sDash_checklist-tasks .ant-checkbox-wrapper .ant-checkbox-inner {\n  width: 18px;\n  height: 18px;\n  border-color: #c6d0dc;\n}\n.sDash_task-details\n  .ant-modal-body\n  .sDash_checklist-tasks\n  .ant-checkbox-wrapper\n  .ant-checkbox-checked\n  .ant-checkbox-inner {\n  background-color: #20c997;\n}\n.sDash_task-details .ant-modal-body .sDash_checklist-tasks .ant-checkbox-wrapper .ant-checkbox-checked:after {\n  border-color: #20c997;\n}\n\n.sDash_task-details .ant-modal-body .sDash_checklist-item .sDash_checklist-tasks-wrap button {\n  padding: 0px 35px;\n}\n\n.sDash_task-details .ant-modal-body {\n  max-height: 800px;\n  overflow-y: auto;\n}\n\n@media (max-width: 767px) {\n  .ant-page-header {\n    padding: 26px 15px 26px 15px !important;\n  }\n}\n\n.page-header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin: -6px -4px;\n}\n\n.page-header-actions button {\n  font-size: 12px;\n  font-weight: 500;\n  height: 34px;\n  padding: 0 12.32px;\n  box-shadow: 0 3px 5px #9299b805;\n  margin: 6px 4px;\n}\n\n.page-header-actions button.ant-btn-white:focus {\n  background-color: #fff !important;\n}\n\n.page-header-actions button + button {\n  margin-left: 8px;\n}\n\n.page-header-actions button.ant-btn-white svg {\n  width: 12px;\n  height: 12px;\n  margin-right: 2px;\n  color: #5f63f2;\n}\n\n/* Layout Css */\n\n.ant-menu-dark .ant-menu-inline.ant-menu-sub,\n.ant-menu.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub {\n  background: #272b41 !important;\n}\n\n.ant-menu-dark .ant-menu-item a {\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.65) !important;\n}\n\n.ant-menu-dark .ant-menu-item a:hover {\n  color: #ffffff;\n}\n\n.ant-menu-dark .ant-menu-submenu span {\n  color: rgba(255, 255, 255, 0.65) !important;\n}\n\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.ant-menu-inline-collapsed-tooltip a {\n  color: #000 !important;\n}\n\n.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  background: transparent;\n}\n\n/* Chart Label */\n\n.chart-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 6px;\n  color: #5a5f7d;\n}\n\n.chart-label .label-dot {\n  margin-right: 8px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n\n.chart-label .label-dot.dot-success {\n  background: #20c997;\n}\n\n.chart-label .label-dot.dot-info {\n  background: #5f63f2;\n}\n\n.chart-label .label-dot.dot-warning {\n  background: #fa8b0c;\n}\n\n/* NOtification CSS */\n\n.ant-notification {\n  z-index: 99999 !important;\n}\n\n.rdrInputRange {\n  padding-left: 10px !important;\n}\n\n/* Overlay Dark */\n.overlay-dark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #10122130;\n  z-index: -1;\n  opacity: 0;\n  visibility: hidden;\n}\n.overlay-dark.show {\n  z-index: 999;\n  opacity: 1;\n  visibility: visible;\n}\n\n.ant-table-thead\n  > tr\n  > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n  display: none;\n}\n\n/* Responsive CSS */\n\n@media only screen and (max-width: 1599px) {\n  .ant-page-header.header-boxed {\n    padding: 26px 130px 26px 130px !important;\n  }\n}\n@media only screen and (max-width: 1500px) {\n  .full-width-table .revenue-table {\n    min-height: 100%;\n  }\n  .pop-confirm .ant-btn {\n    padding: 0 20px;\n    max-width: 60px;\n  }\n  .pop-confirm.pop-confirm-right {\n    margin-left: 300px !important;\n  }\n  .pop-confirm.pop-confirm-bottom,\n  .pop-confirm.pop-confirm-top {\n    margin-left: 80px !important;\n  }\n}\n\n@media only screen and (max-width: 1399px) {\n  .ant-page-header.header-boxed {\n    padding: 26px 50px 26px 50px !important;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .ant-page-header {\n    padding: 0 15px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .ant-page-header.header-boxed {\n    padding: 26px 30px 26px 30px !important;\n  }\n  .rdrMonths .rdrMonth {\n    width: 100%;\n    margin-bottom: 30px;\n  }\n  .rdrDateRangePickerWrapper.PreviewArea {\n    max-height: 300px;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n  .rdrCalendarWrapper.rdrDateRangeWrapper {\n    margin-top: 20px;\n  }\n  .ant-menu-inline-collapsed-tooltip {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .ant-page-header-heading-left {\n    max-width: 320px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .ant-page-header {\n    padding: 26px 15px 26px 15px !important;\n  }\n  .ant-page-header-heading {\n    flex-flow: column;\n    align-items: center;\n    justify-content: center !important;\n  }\n  .ant-page-header-heading-left {\n    max-width: 100%;\n  }\n  .ant-page-header-heading .ant-page-header-heading-title {\n    margin-right: 0;\n    white-space: normal;\n    text-align: center;\n  }\n  .ant-page-header-heading-extra {\n    white-space: normal !important;\n    margin: 12px 0 4px !important;\n  }\n  .ant-page-header-heading-extra .page-header-actions {\n    white-space: normal !important;\n    text-align: center;\n  }\n  .ant-card-body {\n    padding: 20px !important;\n  }\n  .ant-card-head {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n  .ant-pagination .ant-pagination-item,\n  .ant-pagination .ant-pagination-item.ant-pagination-prev,\n  .ant-pagination .ant-pagination-item.ant-pagination-next,\n  .ant-pagination .ant-pagination-jump-prev {\n    margin-right: 5px;\n  }\n  .ant-pagination li.ant-pagination-item,\n  .ant-pagination li.ant-pagination-prev,\n  .ant-pagination li.ant-pagination-next {\n    height: 25px;\n    min-width: 25px;\n    line-height: 22px;\n  }\n  .ant-pagination li.ant-pagination-prev .anticon,\n  .ant-pagination li.ant-pagination-next .anticon {\n    vertical-align: 0.15em;\n  }\n  .ant-table-pagination {\n    float: none !important;\n    text-align: center;\n  }\n  .ant-table-pagination li.ant-pagination-total-text {\n    display: block;\n    margin-bottom: 8px;\n  }\n  .ant-table-pagination li {\n    margin-right: 8px !important;\n  }\n  .ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n    height: 25px !important;\n  }\n  .ant-pagination .ant-select-single .ant-select-selector .ant-select-selection-item {\n    line-height: 23px !important;\n  }\n  .rdrDefinedRangesWrapper {\n    border-right: 0 none;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .btn-inc,\n  .btn-dec {\n    height: 30px;\n    width: 30px;\n  }\n  .ant-page-header {\n    padding: 16px 20px !important;\n  }\n  .ant-layout-header {\n    height: auto;\n  }\n  .ant-card-head {\n    line-height: 1;\n  }\n  .ant-card-head-title {\n    white-space: normal !important;\n  }\n  .pop-confirm .ant-btn {\n    max-width: 60px;\n    padding: 0 20px;\n  }\n  .pop-confirm.pop-confirm-right {\n    margin-left: 320px !important;\n  }\n  .pop-confirm.pop-confirm-bottom {\n    margin-left: 95px !important;\n  }\n  /* Card Heading */\n  .ant-card-head-wrapper {\n    flex-flow: column;\n    align-items: center;\n  }\n  .ant-card-head-wrapper .ant-card-extra {\n    padding: 10px 0 16px !important;\n    float: none;\n    margin: 0;\n    flex-flow: column;\n  }\n  .ant-card-head-wrapper .ant-card-extra .ant-dropdown-trigger + .card-nav {\n    margin-bottom: 8px;\n  }\n  .ant-card-head-wrapper .ant-card-extra .ant-dropdown-trigger {\n    margin: 0 !important;\n  }\n  .ant-card-head-wrapper .ant-card-head-title {\n    padding: 20px 0 0px !important;\n  }\n  .card-nav ul li.active:before {\n    display: none;\n  }\n  .ant-card-head-title > div {\n    display: flex;\n    flex-flow: column;\n    align-items: center;\n  }\n  .ant-card-head-title > div span {\n    margin: 8px 0 0;\n  }\n}\n\n.bmzxig .ant-table tr th:first-child,\n.bmzxig .ant-table tr td:first-child {\n  padding-right: 15px;\n}\n\n/* Emprt */\n\n.ant-empty .ant-empty-footer button {\n  padding: 0px 15.58px !important;\n}\n\n/* Add Event Modal */\n.addEvent-modal .ant-modal-header {\n  padding: 20px 25px;\n}\n.addEvent-modal .ant-modal-header .ant-modal-close-x svg {\n  color: #5a5f7d;\n}\n.addEvent-modal .ant-modal-header .ant-modal-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: #272b41;\n}\n\n.addEvent-modal .ant-modal-body {\n  padding: 23px 25px;\n}\n\n/* Event Dropdown */\n\n.event-dropdown {\n  min-width: auto !important;\n  max-width: 450px;\n  padding: 0 !important;\n  margin: 6px 0 0 !important;\n  box-shadow: 0 10px 40px #9299b820 !important;\n}\n\n.event-dropdown div {\n  border-radius: 8px;\n}\n\n.event-dropdown .ant-card {\n  width: 100% !important;\n  margin-bottom: 0 !important;\n}\n\n@media only screen and (max-width: 479px) {\n  .placement-confirm {\n    display: flex;\n    flex-wrap: wrap;\n    margin: -5px -10px 0 -5px;\n  }\n  .placement-confirm .pop-confirm {\n    flex: 0 0 50%;\n  }\n  .pop-confirm .ant-btn {\n    display: block;\n    padding: 0 20px;\n    max-width: 80px;\n    min-width: 80px;\n    margin: 10px;\n  }\n  .pop-confirm.pop-confirm-right {\n    margin-left: 0px !important;\n  }\n  .pop-confirm.pop-confirm-top {\n    margin-left: 0px !important;\n  }\n  .pop-confirm.pop-confirm-bottom {\n    margin-left: 0px !important;\n    margin-top: 0px !important;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .ant-select {\n    width: 100% !important;\n  }\n  .rdrDefinedRangesWrapper {\n    width: 100% !important;\n  }\n  .rdrDateRangePickerWrapper {\n    flex-wrap: wrap;\n  }\n  .atbd-top-dropdwon {\n    width: 280px;\n    min-width: 180px;\n  }\n  .atbd-top-dropdwon .atbd-top-dropdwon__title {\n    min-height: 40px;\n  }\n  .atbd-top-dropdwon .atbd-top-dropdwon__nav li:not(:last-child) {\n    margin-bottom: 10px;\n  }\n  .atbd-top-dropdwon .atbd-top-dropdwon__nav li a {\n    padding: 10px 0px;\n  }\n  .atbd-top-dropdwon .atbd-top-dropdwon__content img {\n    margin-right: 15px;\n  }\n  .atbd-top-dropdwon .atbd-top-dropdwon__content figcaption {\n    margin-left: 0;\n  }\n  .atbd-top-dropdwon .atbd-top-dropdwon__content figcaption .atbd-top-dropdwonText {\n    min-width: 155px;\n  }\n  .ant-drawer-content-wrapper {\n    width: 260px !important;\n  }\n  .rdrCalendarWrapper.rdrDateRangeWrapper {\n    margin-top: 0;\n  }\n}\n\n@media only screen and (max-width: 379px) {\n  .ant-card-head-wrapper .ant-card-extra .ant-radio-button-wrapper {\n    height: 32px !important;\n    line-height: 30px !important;\n  }\n  .ant-notification-notice {\n    width: 275px;\n  }\n}\n\n@media (max-width: 991px) {\n  .mail-sideabr {\n    box-shadow: 0 0 10px #00000020;\n  }\n}\n\n/* Invoice Print Style */\n@media print {\n  .invoice-area .ant-page-header {\n    display: none;\n  }\n  .customizer-trigger {\n    display: none;\n  }\n}\n\n/* .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{\n  color: #fff !important;\n} */\n\n/* custom label */\n\n/* card spin loader */\n\n.ant-card-body .sd-spin div,\n.ant-card-body .spin div {\n  position: relative;\n}\n\n.ant-card-body .sd-spin,\n.ant-card-body .spin {\n  height: 200px;\n}\n\n.ant-card-body {\n  position: relative;\n}\n\n.ant-card-body .sd-spin .ant-spin,\n.ant-card-body .spin .ant-spin {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  min-height: 200px;\n}\n\n.starActive svg {\n  color: red;\n}\n\n/* vectormap zoom in / zoom out */\n\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  width: 27px;\n  height: 27px;\n  background: none;\n  color: #5a5f7d;\n  border: 1px solid #f1f2f6;\n  padding: 0;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: auto;\n  right: 0;\n  top: auto;\n  background-color: #fff;\n}\n\n.jvectormap-zoomin {\n  border-radius: 6px 6px 0 0;\n  bottom: 36px;\n}\n\n.jvectormap-zoomout {\n  border-radius: 0 0 6px 6px;\n  bottom: 10px;\n}\n\n.jvectormap-tip {\n  padding: 7px 12px;\n  border: 0 none;\n  font-size: 12px;\n  background: #272b41;\n}\n\n.btn-rtl {\n  width: 60px;\n  height: 60px;\n  border: 1px solid #fff;\n  background: #4347d9;\n  color: #fff;\n  position: fixed;\n  right: 0;\n  top: 50%;\n  margin-top: -30px;\n  z-index: 99999999;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* masonry-grid start from here */\n\n.my-masonry-grid {\n  display: -webkit-box;\n  /* Not needed if autoprefixing */\n  display: -ms-flexbox;\n  /* Not needed if autoprefixing */\n  display: flex;\n  margin-left: -10px;\n  /* gutter size offset */\n  width: auto;\n}\n\n.my-masonry-grid_column {\n  padding-left: 10px;\n  /* gutter size */\n  background-clip: padding-box;\n}\n\n/* Style your items */\n\n.my-masonry-grid_column > div {\n  /* change div to reference your elements you put in <Masonry> */\n  background: grey;\n  margin-bottom: 30px;\n}\n\n.common-ul {\n  padding: 5px 0;\n  padding-left: 10px;\n}\n\n.display {\n  display: none;\n}\n\nli.active > .display {\n  display: block;\n}\n\n/* rtl section from here */\nhtml[dir='rtl'] .ant-card-head-title span {\n  margin-right: 15px;\n}\nhtml[dir='rtl'] span[aria-label='arrow-right'] svg,\nhtml[dir='rtl'] span[aria-label='arrow-left'] svg {\n  transform: rotateY(180deg);\n}\n\nhtml[dir='rtl'] .ant-menu.ant-menu-vertical {\n  text-align: right !important;\n}\n\nhtml[dir='rtl'] .ant-menu.ant-menu-vertical .ant-menu-submenu-placement-rightTop {\n  left: -170px !important;\n}\n\nhtml[dir='rtl'] .ant-menu.ant-menu-vertical .ant-menu-vertical-left {\n  text-align: right;\n}\n\nhtml[dir='rtl'] .ant-menu.ant-menu-vertical .ant-menu-submenu-arrow {\n  right: auto;\n  left: 16px;\n  transform: rotateY(180deg);\n}\n\nhtml[dir='rtl'] .ant-menu-vertical .ant-menu-submenu-title {\n  padding-right: 15px !important;\n}\n\n/* Auth0 style */\n.auth0-lock.auth0-lock .auth0-lock-header-logo {\n  width: 180px !important;\n  margin: 0 !important;\n  display: none !important;\n}\n\n.auth0-lock.auth0-lock .auth0-lock-name {\n  font-size: 18px !important;\n}\n\n.auth0-lock.auth0-lock .auth0-lock-close-button,\n.auth0-lock.auth0-lock .auth0-lock-back-button {\n  box-shadow: none !important;\n  padding: 2px !important;\n}\n.common-ul {\n  padding: 5px 0;\n  padding-left: 10px;\n}\n\n.display {\n  display: none;\n}\n\nli.active > .display {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
